<template>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-between align-items-center">
            <div>
              <h3 class="card-title text-gradient">Chấm công & Lệnh</h3>
              <ul class="breadcrumb mb-0">
                <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
                <li class="breadcrumb-item active">Chấm công</li>
              </ul>
            </div>

            <!-- Nút xuất PDF -->
            <button class="btn btn-outline-danger btn-sm" @click="exportPdfReport">
              <i class="fa fa-file-pdf-o mr-1"></i> Xuất báo cáo PDF
            </button>
          </div>
        </div>
      </div>

      <!-- /Page Header -->

      <div class="row">
        <!-- Timesheet -->
        <div class="col-md-4">
          <div class="card punch-status border-left-primary">
            <div class="card-body">
              <h5 class="card-title d-flex align-items-center">
                Chấm công hằng ngày
                <small class="text-muted ml-2">{{ formatDateHuman(now) }}</small>
              </h5>

              <div class="punch-det">
                <h6>Chấm vào (sớm nhất)</h6>
                <p v-if="firstCheckIn">{{ formatDateTime(firstCheckIn) }}</p>
                <p v-else class="text-muted">Chưa có</p>
              </div>

              <div class="punch-info">
                <div class="punch-hours">
                  <span class="badge badge-pill badge-primary px-3 py-2">
                    {{ (attendanceToday?.soCong ?? 0).toFixed(2) }} công
                  </span>
                </div>
              </div>

              <div class="punch-btn-section">
                <button type="button" class="btn punch-btn btn-cta w-100" :class="punchButtonClass"
                  :disabled="punching || loadingAttendance || (isFullDay && !hasOpenSession)" @click="handlePunch">
                  <span v-if="punching" class="spinner-border spinner-border-sm mr-1"></span>
                  <i v-else class="fa" :class="hasOpenSession ? 'fa-sign-out' : 'fa-sign-in'"></i>
                  {{ punchButtonLabel }}
                </button>
              </div>

              <!-- Nút xin nghỉ phép -->
              <div class="mt-2">
                <button type="button" class="btn btn-outline-success btn-cta w-100"
                  :disabled="punching || loadingAttendance" @click="openLeaveModal"
                  title="Tạo đơn nghỉ phép (chọn ngày/buổi)">
                  <i class="fa fa-calendar-plus-o mr-1"></i> Xin nghỉ phép
                </button>
              </div>

              <!-- Ứng lương -->
               <div class="mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-cta w-100"
                    :disabled="punching || loadingAttendance || tamUng.my.acting"
                    @click="openTamUngModal"
                    title="Tạo yêu cầu ứng lương"
                  >
                    <i class="fa fa-money mr-1"></i> Ứng lương
                  </button>
                </div>


              <div class="statistics mt-3">
                <div class="row">
                  <div class="col-md-6 col-6 text-center">
                    <div class="stats-box">
                      <p>Công hôm nay</p>
                      <h6><span class="text-success">{{ (attendanceToday?.soCong ?? 0).toFixed(2) }}</span> / 1.00</h6>
                    </div>
                  </div>
                  <div class="col-md-6 col-6 text-center">
                    <div class="stats-box">
                      <p>Trạng thái</p>
                      <h6>
                        <span v-if="hasOpenSession" class="text-warning">Đang làm</span>
                        <span v-else class="text-success">Đã đóng</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div class="punch-det mt-3">
                <h6>Chấm ra (muộn nhất)</h6>
                <p v-if="lastCheckOut">{{ formatDateTime(lastCheckOut) }}</p>
                <p v-else class="text-muted">Chưa có</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Thống kê -->
        <div class="col-md-4">
          <div class="card att-statistics border-left-warning">
            <div class="card-body">
              <h5 class="card-title">Thống kê</h5>
              <div class="stats-list">

                <!-- Công hôm nay -->
                <div class="stats-info">
                  <p>Hôm nay
                    <strong class="text-primary">
                      {{ Number(stats.todayCong ?? 0).toFixed(2) }}
                      <small>/ 1.00 công</small>
                    </strong>
                  </p>
                  <div class="progress">
                    <div class="progress-bar bg-primary" role="progressbar"
                      :style="{ width: pct(stats.todayCong ?? 0, 1) + '%' }"
                      :aria-valuenow="pct(stats.todayCong ?? 0, 1)" aria-valuemin="0" aria-valuemax="100">
                    </div>
                  </div>
                </div>

                <!-- Công Chủ nhật trong tháng (tính theo CÔNG) -->
                <div class="stats-info">
                  <p>Công Chủ nhật (tháng)
                    <strong class="text-info">
                      {{ Number(stats.monthSundayCong ?? 0).toFixed(2) }} công
                    </strong>
                  </p>
                </div>

                <!-- Giờ Điều động trong tháng (tính theo GIỜ) -->
                <div class="stats-info">
                  <p>Giờ Điều động (tháng)
                    <strong class="text-info">
                      {{ Number(stats.dieuDongGio ?? stats.monthDieuDongHours ?? kpis.dieuDongHours ?? 0).toFixed(2) }}
                      giờ
                    </strong>
                  </p>
                </div>

                <!-- Giờ Tăng ca trong tháng (tính theo GIỜ) -->
                <div class="stats-info">
                  <p>Giờ Tăng ca (tháng)
                    <strong class="text-info">
                      {{ Number(stats.tangCaGio ?? stats.monthTangCaHours ?? kpis.overtimeHours ?? 0).toFixed(2) }} giờ
                    </strong>
                  </p>
                </div>

                <hr class="my-2" />

                <!-- Tổng phút đi sớm trong tháng -->
                <div class="stats-info">
                  <p>Tổng phút đi sớm (tháng)
                    <strong class="text-muted">
                      {{ stats.monthMinutesVaoSom ?? 0 }} phút
                    </strong>
                  </p>

                </div>

                <!-- Tổng phút đi trễ trong tháng -->
                <div class="stats-info">
                  <p>Tổng phút đi trễ (tháng)
                    <strong class="text-danger">
                      {{ stats.monthMinutesVaoTre ?? 0 }} phút
                    </strong>
                  </p>

                </div>

                <!-- Tổng phút về sớm trong tháng -->
                <div class="stats-info">
                  <p>Tổng phút về sớm (tháng)
                    <strong class="text-warning">
                      {{ stats.monthMinutesRaSom ?? 0 }} phút
                    </strong>
                  </p>

                </div>

                <!-- Số lần quên chấm công trong tháng -->
                <div class="stats-info">
                  <p>Số lần quên chấm (tháng)
                    <strong class="text-danger">
                      {{ stats.monthQuenChamCount ?? 0 }} lần
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Hoạt động hôm nay -->
        <div class="col-md-4">
          <div class="card recent-activity border-left-success">
            <div class="card-body">
              <h5 class="card-title">Hoạt động hôm nay</h5>
              <ul class="res-activity-list">
                <li v-for="(it, i) in todayActivityList" :key="i">
                  <p class="mb-0">{{ it.label }}</p>
                  <p class="res-activity-time">
                    <i class="fa fa-clock-o"></i>
                    {{ it.time }}
                    <span v-if="it.extra" class="text-muted"> — {{ it.extra }}</span>
                  </p>
                  <p v-if="it.diaChi" class="res-activity-time">
                    <i class="fa fa-map-marker"></i>
                    {{ it.diaChi }}
                  </p>
                </li>
                <li v-if="todayActivityList.length === 0" class="text-muted">Chưa có hoạt động</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== LỆNH CỦA TÔI ===== -->
      <div class="row mt-3">
        <!-- Pending -->
        <div class="col-lg-4">
          <div class="card shadow-soft">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">Lệnh chờ xác nhận</h5>
                <span class="badge bg-warning">{{ lenh.pending.length }}</span>
              </div>

              <div class="mt-2" v-if="pendingPager.totalPages > 1">
                <div class="d-flex align-items-center justify-content-between">
                  <small class="text-muted">Trang {{ pendingPager.number + 1 }}/{{ pendingPager.totalPages }}</small>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-secondary" :disabled="pendingPager.number === 0"
                      @click="changePendingPage(pendingPager.number - 1)">‹</button>
                    <button class="btn btn-outline-secondary"
                      :disabled="pendingPager.number >= pendingPager.totalPages - 1"
                      @click="changePendingPage(pendingPager.number + 1)">›</button>
                  </div>
                </div>
              </div>

              <div v-if="lenh.pending.length === 0" class="text-muted">Không có lệnh đang chờ.</div>

              <div v-for="l in pagedPending" :key="l.idLenh" class="order-card border rounded p-2 mb-2 order-pending">
                <a href="#" class="fw-bold order-title-link" v-tooltip="'Xem chi tiết lệnh'"
                  @click.prevent="showLenhDetail(l)">
                  {{ l.tieuDe }}
                </a>
                <div class="small text-muted ellipsis-2">{{ l.moTa }}</div>
                <div class="small mt-1">
                  <b>Loại:</b> <span class="badge badge-secondary mr-1">{{ l.loaiLenh }}</span>
                  <b>Kiểu:</b> <span
                    :class="['badge', l.kieuThuong === 'HOURLY' ? 'badge-primary' : 'badge-success']">{{
                      l.kieuThuong }}</span>
                </div>
                <div class="small mt-1">
                  <b>Bắt đầu:</b> {{ formatDateTime(l.batDau) }}
                  <span v-if="l.ketThuc"> • <b>Kết thúc:</b> {{ formatDateTime(l.ketThuc) }}</span>
                </div>
                <div class="small mt-1"><b>Đơn giá:</b> {{ formatMoney(l.tienCong) }}</div>
                <div class="small mt-1" v-if="l.hoTroCom || l.hoTroXangXe">
                  <span v-if="l.hoTroCom"><b>HT cơm:</b> {{ formatMoney(l.hoTroCom) }}</span>
                  <span v-if="l.hoTroXangXe" class="ml-1"><b>HT xăng:</b> {{ formatMoney(l.hoTroXangXe) }}</span>
                </div>
                <div class="mt-2 d-flex flex-wrap gap-2">
                  <button class="btn btn-sm btn-success flex-fill" :disabled="lenh.acting"
                    @click="confirmLenh(l, true)">
                    <i class="fa fa-check mr-1"></i> Đồng ý
                  </button>
                  <button class="btn btn-sm btn-outline-danger flex-fill" :disabled="lenh.acting"
                    @click="confirmLenh(l, false)">
                    <i class="fa fa-times mr-1"></i> Từ chối
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Active -->
        <div class="col-lg-4">
          <div class="card shadow-soft">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">Lệnh đang thực hiện</h5>
                <span class="badge bg-info">{{ lenh.active.length }}</span>
              </div>

              <div class="mt-2" v-if="activePager.totalPages > 1">
                <div class="d-flex align-items-center justify-content-between">
                  <small class="text-muted">Trang {{ activePager.number + 1 }}/{{ activePager.totalPages }}</small>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-secondary" :disabled="activePager.number === 0"
                      @click="changeActivePage(activePager.number - 1)">‹</button>
                    <button class="btn btn-outline-secondary"
                      :disabled="activePager.number >= activePager.totalPages - 1"
                      @click="changeActivePage(activePager.number + 1)">›</button>
                  </div>
                </div>
              </div>

              <div v-if="lenh.active.length === 0" class="text-muted mt-1">Chưa có lệnh đang làm.</div>

              <div v-for="l in pagedActive" :key="l.idLenh" class="order-card border rounded p-2 mb-2 order-active">
                <div class="d-flex align-items-center justify-content-between">
                  <a href="#" class="fw-bold order-title-link" v-tooltip="'Xem chi tiết lệnh'"
                    @click.prevent="showLenhDetail(l)">
                    {{ l.tieuDe }}
                  </a>
                  <span class="badge"
                    :class="l.trangThai === 'RUNNING' ? 'badge-info' : (l.trangThai === 'ENDED' ? 'badge-success' : 'badge-secondary')">
                    {{ l.trangThai }}
                  </span>
                </div>

                <div class="small text-muted ellipsis-2">{{ l.moTa }}</div>
                <div class="small mt-1">
                  <b>Loại:</b> <span class="badge badge-secondary mr-1">{{ l.loaiLenh }}</span>
                  <b>Kiểu:</b> <span
                    :class="['badge', l.kieuThuong === 'HOURLY' ? 'badge-primary' : 'badge-success']">{{
                      l.kieuThuong }}</span>
                </div>
                <div class="small mt-1">
                  <b>Thời gian:</b> {{ formatDateTime(l.batDau) }} <span v-if="l.ketThuc">→ {{ formatDateTime(l.ketThuc)
                  }}</span>
                </div>
                <div class="small mt-1"><b>Đơn giá:</b> {{ formatMoney(l.tienCong) }}</div>
                <div class="small mt-1" v-if="l.hoTroCom || l.hoTroXangXe">
                  <span v-if="l.hoTroCom"><b>HT cơm:</b> {{ formatMoney(l.hoTroCom) }}</span>
                  <span v-if="l.hoTroXangXe" class="ml-1"><b>HT xăng:</b> {{ formatMoney(l.hoTroXangXe) }}</span>
                </div>
                <div class="mt-2">
                  <button class="btn btn-primary btn-cta w-100" :disabled="lenh.acting || !canPunchLenh(l)"
                    @click="handleLenhPunch(l)">
                    <i class="fa" :class="lenhHasOpen(l) ? 'fa-sign-out' : 'fa-sign-in'"></i>
                    {{ lenhHasOpen(l) ? 'Chấm ra lệnh' : 'Chấm vào lệnh' }}
                  </button>
                </div>

                <!-- THUMB ảnh -->
                <div v-if="l.chamCong && (l.chamCong.anhVaoUrl || l.chamCong.anhRaUrl)" class="mt-2">
                  <div class="small mb-1 font-weight-bold">Ảnh của tôi</div>
                  <div class="d-flex gap-2">
                    <img v-if="l.chamCong.anhVaoUrl" :src="l.chamCong.anhVaoUrl" class="img-thumb clickable"
                      @click="openLB([l.chamCong.anhVaoUrl, l.chamCong.anhRaUrl].filter(Boolean), 0)">
                    <img v-if="l.chamCong.anhRaUrl" :src="l.chamCong.anhRaUrl" class="img-thumb clickable"
                      @click="openLB([l.chamCong.anhVaoUrl, l.chamCong.anhRaUrl].filter(Boolean), l.chamCong.anhVaoUrl ? 1 : 0)">
                  </div>
                </div>

                <div v-if="l.chamCong" class="small mt-2">
                  <div>Vào: {{ l.chamCong.gioVao ? formatDateTime(l.chamCong.gioVao) : '—' }} ({{
                    l.chamCong.vaoTrangThai || '—' }})</div>
                  <div>Ra: {{ l.chamCong.gioRa ? formatDateTime(l.chamCong.gioRa) : '—' }} ({{ l.chamCong.raTrangThai ||
                    '—' }})</div>
                  <div v-if="l.kieuThuong === 'HOURLY'">Giờ thưởng: <span class="badge badge-light">{{
                    l.chamCong.soGioThuong ?? 0 }}</span></div>
                  <div v-else>Công thưởng: <span class="badge badge-light">{{ l.chamCong.soCongThuong ?? 0 }}</span>
                  </div>
                  <div>Tiền thưởng: <span class="badge badge-success">{{ formatMoney(l.chamCong.soTienThuong ?? 0)
                  }}</span></div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Done -->
        <div class="col-lg-4">
          <div class="card shadow-soft">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">Lệnh đã hoàn thành</h5>
                <span class="badge bg-success">{{ filteredDone.length }}</span>
              </div>

              <div class="mt-2" v-if="pageDone.totalPages > 1">
                <div class="d-flex align-items-center justify-content-between">
                  <small class="text-muted">Trang {{ pageDone.number + 1 }}/{{ pageDone.totalPages }}</small>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-secondary" :disabled="pageDone.number === 0"
                      @click="onDonePageChange(pageDone.number - 1)">‹</button>
                    <button class="btn btn-outline-secondary" :disabled="pageDone.number >= pageDone.totalPages - 1"
                      @click="onDonePageChange(pageDone.number + 1)">›</button>
                  </div>
                </div>
              </div>

              <div v-if="pagedDone.length === 0" class="text-muted mt-2">Chưa có lệnh hoàn thành.</div>

              <div v-for="l in pagedDone" :key="'d' + l.idLenh" class="order-card border rounded p-2 mb-2 order-done">
                <div class="d-flex align-items-center justify-content-between">
                  <a href="#" class="fw-bold order-title-link" v-tooltip="'Xem chi tiết lệnh'"
                    @click.prevent="showLenhDetail(l)">
                    {{ l.tieuDe }}
                  </a>
                  <span class="badge badge-success">DONE</span>
                </div>
                <div class="small text-muted ellipsis-2">{{ l.moTa }}</div>
                <div class="small mt-1">
                  <b>Loại:</b> <span class="badge badge-secondary mr-1">{{ l.loaiLenh }}</span>
                  <b>Kiểu:</b> <span
                    :class="['badge', l.kieuThuong === 'HOURLY' ? 'badge-primary' : 'badge-success']">{{
                      l.kieuThuong }}</span>
                </div>
                <div class="small mt-1">
                  <b>Thời gian:</b> {{ formatDateTime(l.batDau) }} <span v-if="l.ketThuc">→ {{ formatDateTime(l.ketThuc)
                  }}</span>
                </div>

                <div v-if="l.chamCong && (l.chamCong.anhVaoUrl || l.chamCong.anhRaUrl)" class="mt-1">
                  <div class="d-flex gap-2">
                    <img v-if="l.chamCong.anhVaoUrl" :src="l.chamCong.anhVaoUrl" class="img-thumb clickable"
                      @click="openLB([l.chamCong.anhVaoUrl, l.chamCong.anhRaUrl].filter(Boolean), 0)">
                    <img v-if="l.chamCong.anhRaUrl" :src="l.chamCong.anhRaUrl" class="img-thumb clickable"
                      @click="openLB([l.chamCong.anhVaoUrl, l.chamCong.anhRaUrl].filter(Boolean), l.chamCong.anhVaoUrl ? 1 : 0)">
                  </div>
                </div>

                <div class="small mt-1">
                  Vào: {{ l.chamCong?.gioVao ? formatDateTime(l.chamCong.gioVao) : '—' }} —
                  Ra: {{ l.chamCong?.gioRa ? formatDateTime(l.chamCong.gioRa) : '—' }}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- /LỆNH CỦA TÔI -->

      <!-- ===== NGHỈ PHÉP CỦA TÔI ===== -->
      <div class="row mt-3">
        <div class="col-lg-6">
          <div class="card shadow-soft">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">Nghỉ phép của tôi</h5>
                <span class="badge bg-secondary">{{ leavePage.totalElements }}</span>
              </div>

              <!-- Bộ lọc -->
              <div class="row small mt-2">
                <div class="col-6 mb-1">
                  <input type="date" class="form-control form-control-sm" v-model="leaveFilter.from"
                    placeholder="Từ ngày">
                </div>
                <div class="col-6 mb-1">
                  <input type="date" class="form-control form-control-sm" v-model="leaveFilter.to"
                    placeholder="Đến ngày">
                </div>
                <div class="col-7 mb-1">
                  <select class="form-control form-control-sm" v-model="leaveFilter.status">
                    <option value="ALL">Tất cả trạng thái</option>
                    <option value="PENDING">Chờ duyệt</option>
                    <option value="APPROVED">Đã duyệt</option>
                    <option value="REJECTED">Từ chối</option>
                    <option value="CANCELLED">Đã huỷ</option>
                  </select>
                </div>
                <div class="col-5 mb-1">
                  <input type="text" class="form-control form-control-sm" v-model.trim="leaveFilter.keyword"
                    placeholder="Từ khoá">
                </div>
              </div>

              <!-- Loading -->
              <div v-if="leaves.loading" class="text-muted mt-2">Đang tải đơn nghỉ…</div>

              <!-- Empty -->
              <div v-else-if="!leaves.list.length" class="text-muted mt-2">Không có đơn nghỉ.</div>

              <!-- List -->
              <div v-else class="mt-6">
                <div v-for="lv in leaves.list" :key="lv.idNghiPhep" class="leave-card border rounded p-2 mb-2"
                  :class="leaveCardClass(lv.trangThai)">

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="fw-bold">{{ leaveTitle(lv) }}</div>
                    <span class="badge" :class="statusBadgeClass(lv.trangThai)">
                      {{ mapStatus(lv.trangThai) }}
                    </span>
                  </div>

                  <div class="small text-muted mt-1">
                    <b>Khoảng:</b>
                    {{ formatDate(lv.tuNgay) }} <span v-if="lv.denNgay">→ {{ formatDate(lv.denNgay) }}</span>
                  </div>

                  <div class="small mt-1" v-if="calcLeaveUnits(lv) != null">
                    <b>Đơn vị:</b> {{ calcLeaveUnits(lv) }} ngày/buổi
                  </div>

                  <div class="small mt-1" v-if="lv.lyDo">
                    <b>Lý do:</b> <span class="text-muted">{{ lv.lyDo }}</span>
                  </div>

                  <!-- Chi tiết buổi -->
                  <details class="mt-1" v-if="(lv.chiTiet || lv.chiTietNgay || []).length">
                    <summary class="small">Chi tiết ngày/buổi</summary>
                    <ul class="small mb-0 mt-1 pl-3">
                      <li v-for="(ct, i) in (lv.chiTiet || lv.chiTietNgay || [])" :key="i">
                        {{ formatDate(ct.ngay || ct.date) }} — {{ (ct.buoi || ct.session) }}
                      </li>
                    </ul>
                  </details>

                  <div class="d-flex gap-2 mt-2">
                    <button v-if="canCancelLeave(lv)" class="btn btn-sm btn-outline-danger" :disabled="leaves.acting"
                      @click="cancelLeave(lv)">
                      Huỷ đơn
                    </button>
                    <span class="small text-muted ml-auto">#{{ lv.idNghiPhep }}</span>
                  </div>
                </div>

                <!-- Pager -->
                <div class="d-flex align-items-center justify-content-between mt-2" v-if="leavePage.totalPages > 1">
                  <small class="text-muted">
                    Trang {{ leavePage.number + 1 }}/{{ leavePage.totalPages }}
                  </small>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-secondary" :disabled="leavePage.number === 0 || leaves.loading"
                      @click="changeLeavePage(leavePage.number - 1)">‹</button>
                    <button class="btn btn-outline-secondary"
                      :disabled="leavePage.number >= leavePage.totalPages - 1 || leaves.loading"
                      @click="changeLeavePage(leavePage.number + 1)">›</button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Lệnh hoàn thành theo tháng -->
        <div class="col-lg-6">
          <div class="card shadow-soft border-left-success">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">Lệnh hoàn thành (tháng {{ mm.m }}/{{ mm.y }})</h5>
                <div class="d-flex align-items-center">
                  <button class="btn btn-sm btn-outline-secondary mr-2" @click="prevMonth"
                    :disabled="mm.loading">‹</button>
                  <div class="mx-2 font-weight-bold">{{ mmLabel }}</div>
                  <button class="btn btn-sm btn-outline-secondary ml-2" @click="nextMonth"
                    :disabled="mm.loading">›</button>
                </div>
              </div>

              <div class="table-responsive mt-2">
                <table class="table table-striped table-sm mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="min-width: 120px;">Ngày</th>
                      <th>Tiêu đề</th>
                      <th style="min-width:110px;">Loại</th>
                      <th style="min-width:110px;">Kiểu</th>
                      <th class="text-right" style="min-width:120px;">Giờ/Công</th>
                      <th class="text-right" style="min-width:110px;">Cơm</th>
                      <th class="text-right" style="min-width:110px;">Xăng</th>
                      <th class="text-right" style="min-width:140px;">Tiền tổng</th>
                    </tr>

                  </thead>
                  <tbody>
                    <tr v-for="it in pagedDoneMonth" :key="'dm-' + it.idLenh">
                      <td>{{ formatDate(it.pivotDate) }}</td>
                      <td class="font-weight-500">
                        <a href="#" @click.prevent="showLenhDetail(it)">{{ it.tieuDe }}</a>
                        <div class="small text-muted ellipsis-2">{{ it.moTa }}</div>
                      </td>
                      <td><span class="badge badge-secondary">{{ it.loaiLenh }}</span></td>
                      <td><span class="badge" :class="it.kieuThuong === 'HOURLY' ? 'badge-primary' : 'badge-success'">{{
                        it.kieuThuong }}</span></td>
                      <td class="text-right">
                        <span v-if="it.kieuThuong === 'HOURLY'">{{ (it._hours || 0).toFixed(2) }} h</span>
                        <span v-else>{{ (it._cong || 0).toFixed(2) }} công</span>
                      </td>
                      <td class="text-right">
                        <span v-if="it.hoTroCom && it.hoTroCom > 0">{{ formatMoney(it.hoTroCom) }}</span>
                        <span v-else>—</span>
                      </td>
                      <td class="text-right">
                        <span v-if="it.hoTroXangXe && it.hoTroXangXe > 0">{{ formatMoney(it.hoTroXangXe) }}</span>
                        <span v-else>—</span>
                      </td>
                      <td class="text-right">{{ formatMoney(it._money || 0) }}</td>

                    </tr>
                    <tr v-if="doneMonthRows.length === 0">
                      <td colspan="6" class="text-center text-muted">Không có lệnh hoàn thành trong tháng này.</td>
                    </tr>
                  </tbody>
                  <tfoot v-if="doneMonthRows.length">
                    <tr class="font-weight-bold">
                      <td colspan="5" class="text-right">Tổng</td>
                      <td class="text-right">
                        <span v-if="doneMonthTotals.totalHours > 0">{{ doneMonthTotals.totalHours.toFixed(2) }} h</span>
                        <span v-else>{{ doneMonthTotals.totalCong.toFixed(2) }} công</span>
                      </td>
                      <td class="text-right">{{ formatMoney(doneMonthTotals.totalMoney) }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div class="d-flex align-items-center justify-content-between mt-2" v-if="doneMonthPager.totalPages > 1">
                <small class="text-muted">Trang {{ doneMonthPager.number + 1 }}/{{ doneMonthPager.totalPages }}</small>
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-outline-secondary" :disabled="doneMonthPager.number === 0"
                    @click="changeDoneMonthPage(doneMonthPager.number - 1)">‹</button>
                  <button class="btn btn-outline-secondary"
                    :disabled="doneMonthPager.number >= doneMonthPager.totalPages - 1"
                    @click="changeDoneMonthPage(doneMonthPager.number + 1)">›</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- /NGHỈ PHÉP + DONE THEO THÁNG -->

      <div class="row mt-3">
        <div class="col-lg-12">
          <div class="card shadow-soft">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">Tạm ứng lương của tôi</h5>
                <span class="badge bg-secondary">{{ tamUng.my.page.totalElements }}</span>
              </div>

              <div v-if="tamUng.my.loading" class="text-muted mt-2">Đang tải…</div>
              <div v-else-if="!tamUng.my.list.length" class="text-muted mt-2">Chưa có yêu cầu nào.</div>

              <div v-else class="table-responsive mt-2">
                <table class="table table-sm table-striped mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="min-width:130px;">Ngày tạo</th>
                      <th class="text-right" style="min-width:140px;">Số tiền</th>
                      <th style="min-width:120px;">Trạng thái</th>
                      <th>Ghi chú</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="it in tamUng.my.list" :key="it.id">
                      <td>{{ formatDateTime(it.createdAt || it.ngayTao) }}</td>
                      <td class="text-right font-weight-bold">{{ formatMoney(it.soTien) }}</td>
                      <td>
                        <span class="badge" :class="tamUngStatusBadge(it.trangThai)">
                          {{ it.trangThai }}
                        </span>
                      </td>
                      <td class="text-muted">{{ it.ghiChu || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex align-items-center justify-content-between mt-2" v-if="tamUng.my.page.totalPages > 1">
                <small class="text-muted">Trang {{ tamUng.my.page.number + 1 }}/{{ tamUng.my.page.totalPages }}</small>
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-outline-secondary" :disabled="tamUng.my.page.number === 0" @click="tamUng.changeMyPage(tamUng.my.page.number-1)">‹</button>
                  <button class="btn btn-outline-secondary" :disabled="tamUng.my.page.number >= tamUng.my.page.totalPages-1" @click="tamUng.changeMyPage(tamUng.my.page.number+1)">›</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      <!-- ====== THU NHẬP TẠM TÍNH ====== -->
      <div class="card mt-12 border-left-info">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="card-title mb-0">Thu nhập tạm tính</h5>
            <div class="d-flex align-items-center">
              <button class="btn btn-xs btn-outline-secondary mr-2" @click="prevMonth" :disabled="mm.loading">‹</button>
              <input type="month" class="form-control form-control-sm" style="width:145px" :value="monthInputValue"
                @change="onPickMonth" />
              <button class="btn btn-xs btn-outline-secondary ml-2" @click="nextMonth" :disabled="mm.loading">›</button>
            </div>
          </div>
          <small class="text-muted">Tháng {{ mm.m }}/{{ mm.y }}</small>

          <div v-if="salary.loading" class="text-muted mt-2">Đang tính…</div>
          <div v-else-if="!salary.data" class="text-muted mt-2">Chưa có dữ liệu.</div>

          <div v-else class="mt-2">
            <div class="row small">
              <div class="col-6">Ngày chuẩn:</div>
              <div class="col-6 text-right font-weight-500">{{ salary.data.ngayChuanCty }}</div>

              <div class="col-7">Ngày thực tế đến nay:</div>
              <div class="col-5 text-right font-weight-500">
                {{ Number(salary.data.ngayThucTeDenNgay || 0).toFixed(2) }}
              </div>

              <div class="col-12">
                <hr class="my-2">
              </div>

              <div class="col-7">Khoản (CB+PC−KT) đến nay:</div>
              <div class="col-5 text-right font-weight-bold">
                {{ formatMoney(salary.data.tongThuNhapKhoan_DenNgay) }}
              </div>

              <!-- ====== HỖ TRỢ CƠM / XĂNG (ĐẾN NAY) ====== -->
              <div v-if="salaryTotals.com.now > 0" class="col-7 mt-1">
                Hỗ trợ cơm đến nay:
              </div>
              <div v-if="salaryTotals.com.now > 0" class="col-5 mt-1 text-right">
                <span class="font-weight-500">
                  {{ formatMoney(salaryTotals.com.now) }}
                </span>
                <small v-if="salaryTotals.com.month && salaryTotals.com.month !== salaryTotals.com.now"
                  class="d-block text-muted">
                  Ước cả tháng: {{ formatMoney(salaryTotals.com.month) }}
                </small>
              </div>

              <div v-if="salaryTotals.xang.now > 0" class="col-7 mt-1">
                Hỗ trợ xăng đến nay:
              </div>
              <div v-if="salaryTotals.xang.now > 0" class="col-5 mt-1 text-right">
                <span class="font-weight-500">
                  {{ formatMoney(salaryTotals.xang.now) }}
                </span>
                <small v-if="salaryTotals.xang.month && salaryTotals.xang.month !== salaryTotals.xang.now"
                  class="d-block text-muted">
                  Ước cả tháng: {{ formatMoney(salaryTotals.xang.month) }}
                </small>
              </div>
              <!-- ====== /HỖ TRỢ CƠM / XĂNG ====== -->

              <div class="col-7 mt-1">Thu nhập từ Lệnh:</div>
              <div class="col-5 mt-1 text-right font-weight-bold">
                {{ formatMoney(salary.data.thuNhapLenh_DenNgay) }}
              </div>

              <div class="col-12">
                <hr class="my-2">
              </div>

              <div class="col-7">TẠM TÍNH đến nay:</div>
              <div class="col-5 text-right h5 mb-1 text-success">
                {{ formatMoney(salary.data.tamTinhDenNgay) }}
              </div>

              <div class="col-7 text-muted">ƯỚC TÍNH cuối tháng:</div>
              <div class="col-5 text-right font-weight-500 text-muted">
                {{ formatMoney(salary.data.duKienCuoiThang) }}
              </div>
            </div>


            <details class="mt-2">
              <summary class="small text-primary">Chi tiết khoản</summary>
              <div class="table-responsive mt-2">
                <table class="table table-sm table-bordered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>Tên khoản</th>
                      <th>Loại</th>
                      <th>Cách tính</th>
                      <th class="text-right">Giá trị</th>
                      <th class="text-right">Thực lãnh</th>
                      <th class="text-right">Ước tính</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="it in (salary.data.items || [])" :key="it.idKhoangLuong">
                      <td>{{ it.tenKhoang }}</td>
                      <td>
                        <span class="badge" :class="{
                          'badge-dark': it.loai === 'CO_BAN',
                          'badge-success': it.loai === 'PHU_CAP',
                          'badge-danger': it.loai === 'KHAU_TRU'
                        }">{{ it.loai }}</span>
                      </td>
                      <td><span class="badge badge-info">{{ it.phuongThuc }}</span></td>
                      <td class="text-right">{{ formatMoney(it.giaTriThang) }}</td>
                      <td class="text-right">{{ formatMoney(it.soTienDenNgay) }}</td>
                      <td class="text-right">{{ formatMoney(it.soTienUocTinhThang) }}</td>
                    </tr>
                    <tr v-if="!salary.data.items || !salary.data.items.length">
                      <td colspan="7" class="text-center text-muted">Không có cấu hình khoản.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </details>
          </div>
        </div>
      </div>
      <!-- /THU NHẬP TẠM TÍNH -->

      <!-- ===== LƯỚI THÁNG ===== -->
      <div class="row mt-4">
        <div class="col-lg-12">
          <div class="card shadow-soft">
            <div class="card-body">

              <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 class="card-title mb-0">Lịch công tháng của tôi</h5>
                <div class="d-flex align-items-center">
                  <button class="btn btn-sm btn-outline-secondary mr-2" @click="prevMonth"
                    :disabled="mm.loading">‹</button>
                  <div class="mx-2 font-weight-bold">{{ mmLabel }}</div>
                  <button class="btn btn-sm btn-outline-secondary ml-2" @click="nextMonth"
                    :disabled="mm.loading">›</button>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-striped custom-table table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th style="min-width:260px;">Tôi</th>
                      <th v-for="d in (myMonth?.daysInMonth || 0)" :key="'hd' + d" class="day-col">
                        {{ d }}
                      </th>
                      <th class="text-right" style="min-width:90px;">Tổng công</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="myRow">
                      <td>
                        <h2 class="table-avatar">
                          <span class="avatar avatar-xs mr-2">
                            <img v-if="myRow.avatarUrl" :src="myRow.avatarUrl" alt="">
                            <span v-else class="avatar-fallback">{{ initials(myRow.hoTen) }}</span>
                          </span>
                          <div class="d-inline-flex flex-column">
                            <span class="font-weight-bold">{{ myRow.hoTen }}</span>
                            <small class="text-muted">{{ myRow.phongBan || '—' }}</small>
                          </div>
                        </h2>
                      </td>

                      <td v-for="c in (myRow?.daily || [])" :key="'c' + c.day" class="day-col day-cell"
                        :class="dayCellClasses(c)" @click="openMyDay(c)" :title="cellTooltip(c)">
                        <!-- NGAY_2x -->
                        <template v-if="(myRow?.kieuChamCong || 'NGAY_2x') === 'NGAY_2x'">
                          <div class="half-day">
                            <!-- Hàng 1: VÀO -->
                            <span class="half">
                              <i :class="iconHalf(c, 'AM')"></i>
                            </span>
                            <!-- Hàng 2: RA -->
                            <span class="half">
                              <i :class="iconHalf(c, 'PM')"></i>
                            </span>
                            <!-- Hàng 3: NGHỈ PHÉP NỬA NGÀY / LỆNH -->
                            <span class="half third" v-if="hasPartialLeave(c)">
                              <i class="fa fa-calendar-check-o text-info" :title="leaveSummary(c)"></i>
                            </span>
                            <span class="half third" v-else-if="c.soLenhHoanThanh && c.soLenhHoanThanh > 0">
                              <i class="fa fa-briefcase text-primary"></i>
                              <span class="order-count">{{ c.soLenhHoanThanh }}</span>
                            </span>
                          </div>
                        </template>

                        <!-- BUOI_2x2 -->
                        <template v-else>
                          <div class="quad-day">
                            <div class="quad-row">
                              <span class="quad-item">
                                <i :class="iconBuoi(c, 'AM', 'IN')"></i>
                              </span>
                              <span class="quad-item">
                                <i :class="iconBuoi(c, 'AM', 'OUT')"></i>
                              </span>
                            </div>
                            <div class="quad-row">
                              <span class="quad-item">
                                <i :class="iconBuoi(c, 'PM', 'IN')"></i>
                              </span>
                              <span class="quad-item">
                                <i :class="iconBuoi(c, 'PM', 'OUT')"></i>
                              </span>
                            </div>
                            <!-- Hàng 3: Lệnh hoàn thành -->
                            <div class="quad-row orders-row" v-if="c.soLenhHoanThanh && c.soLenhHoanThanh > 0">
                              <i class="fa fa-briefcase text-primary"></i>
                              <span class="order-count">{{ c.soLenhHoanThanh }}</span>
                            </div>
                          </div>
                        </template>
                      </td>

                      <td class="text-right font-weight-bold">
                        {{ (myRow.totalCong ?? 0).toFixed(2) }}
                      </td>
                    </tr>

                    <tr v-else>
                      <td :colspan="(myMonth?.daysInMonth || 0) + 2" class="text-center text-muted">
                        Không có dữ liệu
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 small text-muted d-flex align-items-center flex-wrap">
                <span class="mr-3"><i class="fa fa-check text-success"></i> Đủ ca</span>
                <span class="mr-3"><i class="fa fa-times text-danger"></i> Nghỉ</span>
                <span class="mr-3"><i class="fa fa-sign-in text-info"></i> Đi sớm</span>
                <span class="mr-3"><i class="fa fa-sign-out text-warning"></i> Về sớm</span>
                <span class="mr-3"><i class="fa fa-clock-o text-warning"></i> Đang mở</span>
                <span class="mr-3"><i class="fa fa-exclamation-circle text-danger"></i> Quên chấm</span>
                <span class="mr-3"><i class="fa fa-calendar-check-o text-info"></i> Nghỉ phép</span>
                <span class="mr-3"><i class="fa fa-gift text-danger"></i> Ngày lễ</span>
                <span class="mr-3"><i class="fa fa-sign-in text-danger"></i> Đi trễ</span>
                <span class="mr-3">
                  <span class="legend-flags order-flags order-flag--defaults">
                    <i class="fa fa-briefcase" style="color: red"></i>
                  </span> Có lệnh
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- /LƯỚI THÁNG -->

    </div>

    <!-- ===== Modal Camera (FULLSCREEN) ===== -->
    <div v-if="camera.open" ref="cameraModalRef" class="camera-modal camera-modal--fs">
      <div class="camera-box camera-box--fs">
        <!-- Top bar -->
        <div class="camera-header camera-header--fs">
          <div class="d-flex align-items-center text-white">
            <b>Chụp ảnh để {{ cameraTitle }}</b>
            <span class="small text-white-50 ml-2" v-if="camera.deviceLabel">({{ camera.deviceLabel }})</span>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn btn-sm btn-outline-light mr-2" @click="switchCamera"
              :disabled="camera.loading || camera.step !== 'live'">
              <i class="fa fa-retweet"></i> Đổi camera
            </button>
            <button class="btn btn-sm btn-outline-light" @click="closeCamera">Đóng</button>
          </div>
        </div>

        <!-- LIVE -->
        <div v-if="camera.step === 'live'">
          <video ref="videoRef" autoplay playsinline muted class="camera-video camera-video--fs"></video>

          <!-- Bottom bar (live) -->
          <div class="camera-actions camera-actions--fs">
            <button class="btn btn-success btn-lg btn-cta btn-cta-fs w-100" :disabled="punching || camera.loading"
              @click="capture()">
              <i class="fa fa-camera mr-1"></i> Chụp
            </button>

            <div class="small text-white-50 mt-2 text-center" v-if="!camera.geo.ready">
              Đang lấy vị trí…
            </div>
            <div class="small text-white-50 mt-1 text-center" v-else-if="camera.geo.lat != null">
              {{ camera.geo.address || (camera.geo.lat.toFixed(6) + ', ' + camera.geo.lng.toFixed(6)) }}
            </div>
          </div>
        </div>

        <!-- CONFIRM -->
        <div v-else class="confirm-pane">
          <img :src="camera.previewUrl" class="confirm-img confirm-img--fs" alt="preview" />

          <!-- Bottom bar (confirm) -->
          <div class="camera-actions camera-actions--fs">
            <div class="d-flex w-100">
              <button class="btn btn-outline-light btn-lg btn-cta btn-cta-fs w-50 mr-2"
                :disabled="punching || camera.loading" @click="retake()">
                <i class="fa fa-refresh mr-1"></i> Chụp lại
              </button>
              <button class="btn btn-success btn-lg btn-cta btn-cta-fs w-50" :disabled="punching || camera.loading"
                @click="sendCaptured()">
                <i class="fa fa-send mr-1"></i> Gửi
              </button>
            </div>
          </div>
        </div>

        <canvas ref="canvasRef" class="d-none"></canvas>
      </div>
    </div>
    <!-- /Modal Camera -->

    <!-- Modal xem chi tiết ngày -->
    <div v-if="dayModal.open">
      <div class="modal custom-modal fade show" style="display:block;" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header border-0">
              <h5 class="modal-title text-gradient">
                {{ myRow?.hoTen }} — {{ formatDateHuman(dayModal.date) }}
              </h5>
              <button type="button" class="close" @click="closeDayModal"><span>&times;</span></button>
            </div>

            <div class="modal-body" v-if="dayModal.detail">
              <div class="row">
                <div class="col-md-6">
                  <div class="card punch-status border-left-info">
                    <div class="card-body">
                      <h5 class="card-title">
                        Tổng hợp
                        <small class="text-muted">{{ formatDateHuman(dayModal.detail.ngay) }}</small>
                      </h5>

                      <div class="punch-det">
                        <h6>Vào sớm nhất</h6>
                        <p>{{ dayModal.detail.gioVaoTong ? formatDateTime(dayModal.detail.gioVaoTong) : '—' }}</p>
                      </div>

                      <div class="punch-info">
                        <div class="punch-hours">
                          <span class="badge badge-pill badge-info px-3 py-2">{{ (dayModal.detail.soCong ??
                            0).toFixed(2) }} công</span>
                        </div>
                      </div>

                      <div class="punch-det">
                        <h6>Ra muộn nhất</h6>
                        <p>{{ dayModal.detail.gioRaTong ? formatDateTime(dayModal.detail.gioRaTong) : '—' }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- LỆNH TRONG NGÀY -->
                <div class="col-md-6">
                  <div class="card recent-activity border-left-secondary">
                    <div class="card-body">
                      <h5 class="card-title">Lệnh trong ngày</h5>

                      <ul class="res-activity-list" v-if="modalOrders.length">
                        <li v-for="it in modalOrders" :key="'mo' + it.idLenh">
                          <p class="mb-0">
                            <i :class="orderIconByLoai(it.loaiLenh).icon" :title="orderIconByLoai(it.loaiLenh).title"
                              :style="{ marginRight: '6px' }"></i>
                            <a href="#" @click.prevent="showLenhDetail(it)">{{ it.tieuDe }}</a>
                          </p>
                          <p class="res-activity-time">
                            <i class="fa fa-clock-o"></i>
                            {{ itTimeRange(it) }}
                            <span class="text-muted"> — {{ it.loaiLenh }} / {{ it.kieuThuong }}</span>
                          </p>
                        </li>
                      </ul>
                      <div v-else class="text-muted">Không có lệnh nào trong ngày.</div>
                    </div>
                  </div>
                </div>
                <!-- /LỆNH TRONG NGÀY -->
              </div>

              <!-- Ảnh chấm công theo buổi -->
              <div class="row"
                v-if="dayModal.detail && Array.isArray(dayModal.detail.chiTietBuoi) && dayModal.detail.chiTietBuoi.length">
                <div class="col-md-6" v-for="b in dayModal.detail.chiTietBuoi" :key="'b' + (b.idCcb || b.buoi)">
                  <div class="card">
                    <div class="card-body">
                      <div class="fw-bold mb-2">
                        Ca
                        <span v-if="b.buoi === 'SANG'"> 1</span>
                        <span v-else-if="b.buoi === 'CHIEU'"> 2</span>
                        <span v-else> Cả ngày</span>
                      </div>

                      <div class="small mb-1">Vào: {{ b.gioVao ? formatDateTime(b.gioVao) : '—' }} ({{ b.vaoTrangThai ||
                        '—' }})</div>
                      <div class="small mb-2">Ra: {{ b.gioRa ? formatDateTime(b.gioRa) : '—' }} ({{ b.raTrangThai || '—'
                      }})</div>

                      <div class="d-flex gap-2">
                        <img v-if="b.anhVaoUrl" :src="b.anhVaoUrl" class="img-thumb clickable"
                          @click="openLB([b.anhVaoUrl, b.anhRaUrl].filter(Boolean), 0)">
                        <img v-if="b.anhRaUrl" :src="b.anhRaUrl" class="img-thumb clickable"
                          @click="openLB([b.anhVaoUrl, b.anhRaUrl].filter(Boolean), b.anhVaoUrl ? 1 : 0)">
                      </div>

                      <div class="small text-muted mt-2" v-if="b.diaDiemVaoText">Vào: {{ b.diaDiemVaoText }}</div>
                      <div class="small text-muted" v-if="b.diaDiemRaText">Ra: {{ b.diaDiemRaText }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="p-4">Đang tải…</div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
    <!-- /Modal chi tiết ngày -->

    <!-- Modal TẠO NGHỈ PHÉP -->
    <div v-if="leaveModal.open">
      <div class="modal custom-modal fade show" style="display:block;" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header border-0">
              <h5 class="modal-title text-gradient">Tạo đơn nghỉ phép</h5>
              <button type="button" class="close" @click="closeLeaveModal"><span>&times;</span></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-md-4 mb-2">
                  <label class="small mb-1">Từ ngày</label>
                  <input type="date" class="form-control" v-model="leaveModal.tuNgay" @change="onLeaveRangeChange">
                </div>
                <div class="col-md-4 mb-2">
                  <label class="small mb-1">Đến ngày</label>
                  <input type="date" class="form-control" v-model="leaveModal.denNgay" @change="onLeaveRangeChange">
                </div>
                <div class="col-12 mb-2">
                  <label class="small mb-1">Lý do</label>
                  <textarea class="form-control" rows="2" v-model.trim="leaveModal.lyDo"
                    placeholder="Nhập lý do nghỉ..."></textarea>
                </div>
              </div>

              <div class="table-responsive mt-2" v-if="leaveModal.items.length">
                <table class="table table-sm table-bordered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 60%;">Ngày</th>
                      <th>Buổi nghỉ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, idx) in leaveModal.items" :key="'lv-' + idx">
                      <td>
                        <div class="d-flex align-items-center">
                          <span class="badge mr-2"
                            :class="{ 'badge-secondary': d.isSunday, 'badge-light': !d.isSunday }">{{
                              d.weekday }}</span>
                          <span class="font-weight-500">{{ d.label }}</span>
                        </div>
                      </td>
                      <td style="min-width:210px;">
                        <select class="form-control form-control-sm" v-model="d.buoi">
                          <option value="NONE">— Không nghỉ —</option>
                          <option value="SANG">Sáng</option>
                          <option value="CHIEU">Chiều</option>
                          <option value="FULL">Cả ngày</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="small text-muted mt-2">
                  Đã chọn: <b>{{ leaveSelectedCount }}</b> ngày/buổi.
                </div>
              </div>

              <div v-else class="text-muted">Chọn khoảng ngày để thiết lập buổi nghỉ.</div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" @click="closeLeaveModal">Hủy</button>
              <button type="button" class="btn btn-success" :disabled="leaveSubmitting || leaveSelectedCount === 0"
                @click="submitLeave">
                <span v-if="leaveSubmitting"><i class="fa fa-spinner fa-spin mr-1"></i> Đang gửi...</span>
                <span v-else><i class="fa fa-check mr-1"></i> Gửi đơn</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
    <!-- /Modal TẠO NGHỈ PHÉP -->

    <!-- Modal ỨNG LƯƠNG -->
    <div v-if="tamUngModal.open">
      <div class="modal custom-modal fade show" style="display:block;" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:520px;">
          <div class="modal-content">
            <div class="modal-header border-0">
              <h5 class="modal-title text-gradient">Ứng lương</h5>
              <button type="button" class="close" @click="closeTamUngModal"><span>&times;</span></button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label class="small mb-1">Số tiền muốn ứng</label>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="tamUngModal.soTien"
                  min="0"
                  step="1000"
                  placeholder="Ví dụ: 500000"
                />
                <small class="text-muted">Đơn sẽ ở trạng thái <b>PENDING</b> chờ admin duyệt.</small>
              </div>

              <div class="form-group mb-0">
                <label class="small mb-1">Ghi chú (tuỳ chọn)</label>
                <textarea class="form-control" rows="2" v-model.trim="tamUngModal.ghiChu" placeholder="Lý do / ghi chú..."></textarea>
              </div>

              <div v-if="tamUng.my.error" class="alert alert-danger mt-2 mb-0">
                {{ tamUng.my.error }}
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-outline-secondary" @click="closeTamUngModal">Huỷ</button>
              <button
                class="btn btn-primary"
                :disabled="tamUng.my.acting || !tamUngModal.soTien || tamUngModal.soTien <= 0"
                @click="submitTamUng"
              >
                <span v-if="tamUng.my.acting"><i class="fa fa-spinner fa-spin mr-1"></i> Đang gửi...</span>
                <span v-else><i class="fa fa-check mr-1"></i> Gửi yêu cầu</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
    <!-- /Modal ỨNG LƯƠNG -->


    <!-- Lightbox ảnh checkin/checkout -->
    <vue-easy-lightbox :visible="lb.visible" :imgs="lb.imgs" :index="lb.index" @hide="lb.visible = false" />
  </div>
</template>

<script>
import api from "@/api";
import Swal from "sweetalert2";
import VueEasyLightbox from "vue-easy-lightbox";
import { useToast } from "vue-toastification";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useTamUngLuongStore } from "@/stores/tamUngLuongStore";

// Khai báo vfs + fonts cho pdfMake (Roboto hỗ trợ tiếng Việt)
pdfMake.vfs = pdfFonts.vfs;

pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};
const GEOAPIFY_KEY = "2209ae8943f74a18b5d0d7676d65cd50";
const WM_LOGO_URL = "/assets/img/profiles/logominhtien.png";

export default {
  name: "AttendanceAndOrders",
  components: { VueEasyLightbox },
  data() {
    const now = new Date();
    return {
      tamUngModal: {
        open: false,
        soTien: null,
        ghiChu: "",
      },


      now,
      loadingAttendance: false,
      punching: false,

      // Attendance
      attendanceToday: null,
      stats: {},
      historyRows: [],

      // Month grid
      mm: { y: now.getFullYear(), m: now.getMonth() + 1, loading: false },
      myMonth: null,

      // Salary preview
      salary: { loading: false, data: null },

      // Day modal
      dayModal: { open: false, date: null, detail: null },

      // Camera
      camera: {
        open: false,
        stream: null,
        for: null,      // 'attendance-in' | 'attendance-out' | 'lenh-in' | 'lenh-out'
        lenhId: null,
        loading: false,
        devices: [],
        deviceIndex: 0,
        lastFacing: 'user',
        deviceLabel: '',
        geo: { ready: false, lat: null, lng: null, address: '' },
        // confirm-flow
        step: 'live',        // 'live' | 'confirm'
        previewUrl: null,    // objectURL cho ảnh đã watermark
        blob: null           // Blob ảnh đã watermark
      },

      // Orders
      _lenhState: { loading: false, acting: false, pending: [], active: [], done: [] },

      // Pagers
      pendingPager: { number: 0, size: 2, totalPages: 1 },
      activePager: { number: 0, size: 2, totalPages: 1 },
      pageDone: { number: 0, size: 2, totalPages: 1 },
      doneMonthPager: { number: 0, size: 5, totalPages: 1 },

      // Lightbox
      lb: { visible: false, imgs: [], index: 0 },

      // Toast
      toast: null,

      // NGHỈ PHÉP
      leaves: { loading: false, acting: false, list: [] },
      leaveFilter: { from: null, to: null, status: "ALL", keyword: "" },
      leavePage: { number: 0, size: 2, totalPages: 1, totalElements: 0 },
      leaveSubmitting: false,

      // Modal tạo nghỉ phép
      leaveModal: { open: false, tuNgay: null, denNgay: null, lyDo: "", items: [] },

      // KPI từ Lệnh trong tháng
      kpis: { sundayDays: 0, overtimeHours: 0, dieuDongHours: 0 },

      // watermark logo cache
      _wmLogo: null,

      // filter cho Done list + bảng tháng theo lệnh
      doneFilter: { from: null, to: null, keyword: "" }
    };
  },
  computed: {
    tamUng() {
      return useTamUngLuongStore();
    },
    // === Chuyển "giờ" -> "công" (8 giờ = 1 công) ===
    todayCong() { return Number(this.stats.todayHours ?? 0) / 8; },
    weekCong() { return Number(this.stats.weekHours ?? 0) / 8; },
    monthCong() { return Number(this.stats.monthHours ?? 0) / 8; },
    monthRemainCong() { return Math.max(0, Number(this.stats.monthRemainingHours ?? 0) / 8); },

    todayTargetCong() { return 1; },
    weekTargetCong() { return (Number(this.stats.weekTargetHours ?? 40) / 8) || 5; },
    monthTargetCong() { return (Number(this.stats.monthTargetHours ?? 160) / 8) || 20; },
    salaryTotals() {
      const items = this.salary?.data?.items || [];
      const totals = {
        phuCapNow: 0,
        phuCapMonth: 0,
        khauTruNow: 0,
        khauTruMonth: 0,
        com: { now: 0, month: 0 },
        xang: { now: 0, month: 0 },
      };

      for (const it of items) {
        const loai = (it.loai || "").toUpperCase(); // CO_BAN / PHU_CAP / KHAU_TRU
        const name = (it.tenKhoang || "").toLowerCase();
        const now = Number(it.soTienDenNgay || 0);           // đến ngày hôm nay
        const month = Number(it.soTienUocTinhThang || 0);    // ước tính cả tháng

        if (loai === "PHU_CAP") {
          totals.phuCapNow += now;
          totals.phuCapMonth += month;

          // đoán tên khoản: cơm / ăn / bữa
          if (name.includes("cơm") || name.includes("ăn") || name.includes("bữa")) {
            totals.com.now += now;
            totals.com.month += month;
          }
          // đoán tên khoản: xăng / xe
          if (name.includes("xăng") || name.includes("xe")) {
            totals.xang.now += now;
            totals.xang.month += month;
          }
        } else if (loai === "KHAU_TRU") {
          totals.khauTruNow += now;
          totals.khauTruMonth += month;
        }
      }

      return totals;
    },
    // Kiểm tra xem có ca nào đang mở (đã chấm vào nhưng chưa chấm ra) không
    hasOpenSession() {
      const at = this.attendanceToday;
      if (!at) return false; // Chưa có dữ liệu -> Cần chấm vào

      // 1. Ưu tiên kiểm tra theo chi tiết buổi (SÁNG/CHIỀU)
      if (Array.isArray(at.chiTietBuoi) && at.chiTietBuoi.length > 0) {
        // Tìm buổi nào có Giờ Vào mà CHƯA có Giờ Ra
        const runningSession = at.chiTietBuoi.find(b => b.gioVao && !b.gioRa);
        return !!runningSession;
      }

      // 2. Fallback: Kiểm tra theo tổng ngày (kiểu chấm công 1 lần/ngày)
      // Có giờ vào tổng nhưng chưa có giờ ra tổng
      const inTime = at.gioVaoTong || at.gioVao;
      const outTime = at.gioRaTong || at.gioRa;

      if (inTime && !outTime) {
        return true;
      }

      return false;
    },

    // Kiểm tra xem đã hoàn thành đủ công hôm nay chưa (>= 1 công)
    isFullDay() {
      return (this.attendanceToday?.soCong ?? 0) >= 1.0;
    },

    // Xác định nhãn hiển thị cho nút bấm
    punchButtonLabel() {
      if (this.loadingAttendance) return 'Đang tải...';
      if (this.hasOpenSession) return 'Chấm ra'; // Đang mở ca -> Cần chấm ra
      if (this.isFullDay) return 'Hoàn thành';    // Đã đủ công
      return 'Chấm vào';                          // Chưa mở ca -> Chấm vào
    },

    // Xác định class màu sắc cho nút bấm
    punchButtonClass() {
      if (this.hasOpenSession) return 'btn-warning'; // Màu vàng
      if (this.isFullDay) return 'btn-secondary';    // Màu xám
      return 'btn-primary';                          // Màu xanh
    },
    firstCheckIn() {
      const at = this.attendanceToday;
      if (!at) return null;

      const times = [];

      // Lấy từ chi tiết buổi nếu có
      if (Array.isArray(at.chiTietBuoi)) {
        at.chiTietBuoi.forEach(b => {
          if (b.gioVao) times.push(+new Date(b.gioVao));
        });
      }

      // Fallback giờ tổng (kiểu NGAY_2x)
      const topIn = at.gioVaoTong || at.gioVao;
      if (topIn) times.push(+new Date(topIn));

      if (!times.length) return null;
      return new Date(Math.min.apply(null, times));
    },
    lastCheckOut() {
      const at = this.attendanceToday;
      if (!at) return null;

      const times = [];

      // Lấy từ chi tiết buổi nếu có
      if (Array.isArray(at.chiTietBuoi)) {
        at.chiTietBuoi.forEach(b => {
          if (b.gioRa) times.push(+new Date(b.gioRa));
        });
      }

      // Fallback giờ tổng (kiểu NGAY_2x)
      const topOut = at.gioRaTong || at.gioRa;
      if (topOut) times.push(+new Date(topOut));

      if (!times.length) return null;
      return new Date(Math.max.apply(null, times));
    },

    workedHoursToday() { return Number(this.attendanceToday?.soCong ?? 0) * 8; },

    todayActivityList() {
      const at = this.attendanceToday;
      if (!at) return [];

      const list = [];

      // 1) Có chi tiết buổi
      if (Array.isArray(at.chiTietBuoi) && at.chiTietBuoi.length) {
        at.chiTietBuoi.forEach(b => {
          if (b.gioVao) {
            list.push({
              label: b.buoi === 'SANG'
                ? 'Vào ca 1'
                : (b.buoi === 'CHIEU' ? 'Vào ca 2' : 'Vào'),
              time: this.formatTime(b.gioVao),
              ts: +new Date(b.gioVao),
              extra: b.vaoTrangThai || '',
              diaChi: b.diaDiemVaoText || ''
            });
          }
          if (b.gioRa) {
            list.push({
              label: b.buoi === 'SANG'
                ? 'Ra ca 1'
                : (b.buoi === 'CHIEU' ? 'Ra ca 2' : 'Ra'),
              time: this.formatTime(b.gioRa),
              ts: +new Date(b.gioRa),
              extra: b.raTrangThai || '',
              diaChi: b.diaDiemRaText || ''
            });
          }
        });
      } else {
        // 2) Kiểu NGAY_2x: dùng giờ tổng của ngày
        const inTime = at.gioVaoTong || at.gioVao;
        const outTime = at.gioRaTong || at.gioRa;

        if (inTime) {
          list.push({
            label: 'Vào làm',
            time: this.formatTime(inTime),
            ts: +new Date(inTime),
            extra: at.vaoTrangThaiTong || at.vaoTrangThai || '',
            diaChi: at.diaDiemVaoTextTong || at.diaDiemVaoText || ''
          });
        }
        if (outTime) {
          list.push({
            label: 'Ra về',
            time: this.formatTime(outTime),
            ts: +new Date(outTime),
            extra: at.raTrangThaiTong || at.raTrangThai || '',
            diaChi: at.diaDiemRaTextTong || at.diaDiemRaText || ''
          });
        }
      }

      return list.sort((a, b) => a.ts - b.ts);
    },

    modalActivities() {
      const d = this.dayModal?.detail;
      if (!d) return [];

      const list = [];

      // 1) Có chi tiết buổi
      if (Array.isArray(d.chiTietBuoi) && d.chiTietBuoi.length) {
        for (const b of d.chiTietBuoi) {
          if (b.gioVao) {
            list.push({
              key: `in-${b.idCcb || b.buoi || b.gioVao}`,
              label: b.buoi === 'SANG'
                ? 'Vào ca sáng'
                : (b.buoi === 'CHIEU' ? 'Vào ca chiều' : 'Vào'),
              time: this.formatTime(b.gioVao),
              ts: +new Date(b.gioVao),
              extra: b.vaoTrangThai || '',
              diaChi: b.diaDiemVaoText || ''
            });
          }
          if (b.gioRa) {
            list.push({
              key: `out-${b.idCcb || b.buoi || b.gioRa}`,
              label: b.buoi === 'SANG'
                ? 'Ra ca sáng'
                : (b.buoi === 'CHIEU' ? 'Ra ca chiều' : 'Ra'),
              time: this.formatTime(b.gioRa),
              ts: +new Date(b.gioRa),
              extra: b.raTrangThai || '',
              diaChi: b.diaDiemRaText || ''
            });
          }
        }
      } else {
        // 2) Fallback cho NGAY_2x
        const inTime = d.gioVaoTong || d.gioVao;
        const outTime = d.gioRaTong || d.gioRa;

        if (inTime) {
          list.push({
            key: `in-${d.ngay || 'day'}`,
            label: 'Vào làm',
            time: this.formatTime(inTime),
            ts: +new Date(inTime),
            extra: d.vaoTrangThaiTong || d.vaoTrangThai || '',
            diaChi: d.diaDiemVaoTextTong || d.diaDiemVaoText || ''
          });
        }
        if (outTime) {
          list.push({
            key: `out-${d.ngay || 'day'}`,
            label: 'Ra về',
            time: this.formatTime(outTime),
            ts: +new Date(outTime),
            extra: d.raTrangThaiTong || d.raTrangThai || '',
            diaChi: d.diaDiemRaTextTong || d.diaDiemRaText || ''
          });
        }
      }

      return list.sort((a, b) => a.ts - b.ts);
    },

    mmLabel() { return `Tháng ${this.mm.m}/${this.mm.y}`; },
    monthInputValue() {
      const m = String(this.mm.m).padStart(2, '0');
      return `${this.mm.y}-${m}`;
    },
    myRow() { return this.myMonth?.rows?.[0] || null; },
    lenh() { return this.$data._lenhState; },

    /* ===== LỆNH ↔ NGÀY trong tháng (để vẽ icon trên lưới) ===== */
    ordersByDate() {
      const map = {};
      try {
        const y = this.mm.y, mIdx = this.mm.m - 1;
        const start = new Date(y, mIdx, 1, 0, 0, 0, 0);
        const end = new Date(y, mIdx + 1, 0, 23, 59, 59, 999);
        const inMonth = (dt) => {
          if (!dt) return false;
          const d = new Date(dt);
          return d >= start && d <= end;
        };
        const collect = (l) => {
          const cc = l.chamCong || {};
          const startEff = cc.effectiveStart || cc.gioVao || l.batDau;
          if (!startEff || !inMonth(startEff)) return;
          const k = this.toLocalYmd(new Date(startEff));
          if (!map[k]) map[k] = [];
          map[k].push(l);
        };
        (this.lenh.active || []).forEach(collect);
        (this.lenh.done || []).forEach(collect);
      } catch { }
      return map;
    },

    /* Modal: lệnh của ngày đang xem */
    modalOrders() {
      if (!this.dayModal?.date) return [];
      return this.ordersByDate[this.dayModal.date] || [];
    },

    filteredDone() {
      const y = this.mm.y;
      const m = this.mm.m; // 1..12
      const monthStart = new Date(y, m - 1, 1, 0, 0, 0, 0);
      const monthEnd = new Date(y, m, 0, 23, 59, 59, 999);

      const inMonth = (dt) => {
        if (!dt) return false;
        const d = new Date(dt);
        return d >= monthStart && d <= monthEnd;
      };

      const f = (x) => {
        const cc = x.chamCong || {};
        const pivot = cc.effectiveStart || cc.gioVao || x.batDau;
        if (!inMonth(pivot)) return false;

        const okKeyword = !this.doneFilter?.keyword
          || (x.tieuDe?.toLowerCase().includes(this.doneFilter.keyword.toLowerCase()))
          || (x.moTa?.toLowerCase().includes(this.doneFilter.keyword.toLowerCase()));
        const okFrom = !this.doneFilter?.from || new Date(pivot) >= this.startOfDayYmd(this.doneFilter.from);
        const okTo = !this.doneFilter?.to || new Date(pivot) <= this.endOfDayYmd(this.doneFilter.to);
        return okKeyword && okFrom && okTo;
      };

      return (this.lenh.done || []).filter(f);
    },

    pagedDone() {
      const start = this.pageDone.number * this.pageDone.size;
      const arr = this.filteredDone.slice(start, start + this.pageDone.size);
      this.pageDone.totalPages = Math.max(1, Math.ceil(this.filteredDone.length / this.pageDone.size));
      if (this.pageDone.number >= this.pageDone.totalPages) this.pageDone.number = this.pageDone.totalPages - 1;
      return arr;
    },

    pagedPending() {
      const start = this.pendingPager.number * this.pendingPager.size;
      const total = (this.lenh.pending || []).length || 0;
      this.pendingPager.totalPages = Math.max(1, Math.ceil(total / this.pendingPager.size));
      if (this.pendingPager.number >= this.pendingPager.totalPages) {
        this.pendingPager.number = this.pendingPager.totalPages - 1;
      }
      return (this.lenh.pending || []).slice(start, start + this.pendingPager.size);
    },

    pagedActive() {
      const start = this.activePager.number * this.activePager.size;
      const total = (this.lenh.active || []).length || 0;
      this.activePager.totalPages = Math.max(1, Math.ceil(total / this.activePager.size));
      if (this.activePager.number >= this.activePager.totalPages) {
        this.activePager.number = this.activePager.totalPages - 1;
      }
      return (this.lenh.active || []).slice(start, start + this.activePager.size);
    },

    cameraTitle() {
      switch (this.camera.for) {
        case "attendance-in": return "chấm vào";
        case "attendance-out": return "chấm ra";
        case "lenh-in": return "check-in lệnh";
        case "lenh-out": return "check-out lệnh";
        default: return "chấm công";
      }
    },

    monthSundayTotal() {
      const y = this.mm.y;
      const mIdx = this.mm.m - 1;
      let d = new Date(y, mIdx, 1);
      let cnt = 0;
      while (d.getMonth() === mIdx) {
        if (d.getDay() === 0) cnt++;
        d.setDate(d.getDate() + 1);
      }
      return cnt || 1;
    },

    doneMonthRows() {
      return this.filteredDone
        .map(l => {
          const cc = l.chamCong || {};
          const startEff = cc.effectiveStart || cc.gioVao || l.batDau;
          const endEff = cc.gioRa || l.ketThuc;

          let hours = Number(cc.soGioThuong ?? 0);
          if (!hours && startEff && endEff) {
            hours = Math.max(0, (new Date(endEff) - new Date(startEff)) / 36e5);
          }
          const cong = Number(cc.soCongThuong ?? 0);
          const money = Number(cc.soTienThuong ?? 0) || (l.kieuThuong === 'HOURLY'
            ? hours * Number(l.tienCong || 0)
            : cong * Number(l.tienCong || 0));

          return {
            ...l,
            pivotDate: startEff,
            _hours: l.kieuThuong === 'HOURLY' ? hours : 0,
            _cong: l.kieuThuong !== 'HOURLY' ? cong : 0,
            _money: money
          };
        })
        .sort((a, b) => new Date(a.pivotDate) - new Date(b.pivotDate));
    },

    doneMonthTotals() {
      return this.doneMonthRows.reduce((acc, it) => {
        acc.totalHours += Number(it._hours || 0);
        acc.totalCong += Number(it._cong || 0);
        acc.totalMoney += Number(it._money || 0);
        return acc;
      }, { totalHours: 0, totalCong: 0, totalMoney: 0 });
    },

    pagedDoneMonth() {
      const start = this.doneMonthPager.number * this.doneMonthPager.size;
      const arr = this.doneMonthRows.slice(start, start + this.doneMonthPager.size);
      this.doneMonthPager.totalPages = Math.max(1, Math.ceil(this.doneMonthRows.length / this.doneMonthPager.size));
      if (this.doneMonthPager.number >= this.doneMonthPager.totalPages) this.doneMonthPager.number = this.doneMonthPager.totalPages - 1;
      return arr;
    },

    leaveSelectedCount() {
      return this.leaveModal.items.filter(x => x.buoi && x.buoi !== 'NONE').length;
    },
  },
  mounted() {
    this.toast = useToast ? useToast() : null;
    this.tickNow();
    this.setDoneMonthRange();

    // preload watermark logo
    const img = new Image();
    img.onload = () => (this._wmLogo = img);
    img.src = WM_LOGO_URL;

    this.fetchToday();
    this.fetchStats();
    this.fetchHistoryThisMonth();
    this.fetchMyLenh();
    this.fetchMyMonth();
    this.fetchSalaryPreview();
    this.fetchMyLeaves();
    this.tamUng.loadMy({ page: 0 });
  },
  beforeUnmount() { this.stopCamera(); },
  watch: {
    doneFilter: { deep: true, handler() { this.pageDone.number = 0; this.doneMonthPager.number = 0; } },
    leaveFilter: {
      deep: true,
      handler() {
        this.leavePage.number = 0;
        this.fetchMyLeaves();
      }
    },
    // Khi đổi tháng hoặc danh sách lệnh đổi, modalOrders/flag tự cập nhật qua computed.
    mm: { deep: true, handler() { } },
    lenh: { deep: true, handler() { } },
  },
  methods: {
    /* =================================================================
 *  EXPORT PDF – BÁO CÁO CHẤM CÔNG & THU NHẬP CÁ NHÂN
 *  Không dùng html2canvas, tự biên soạn nội dung (text + table),
 *  font Roboto hỗ trợ tiếng Việt.
 * ================================================================= */
    exportPdfReport() {
      try {
        const docDefinition = this.buildPdfDocDefinition();
        const fileName = this.buildPdfFileName();
        pdfMake.createPdf(docDefinition).download(fileName);
      } catch (e) {
        console.error(e);
        Swal.fire({
          icon: "error",
          title: "Xuất PDF thất bại",
          text: e?.message || "Không thể tạo báo cáo PDF",
        });
      }
    },

    buildPdfFileName() {
      const ym = `${this.mm.y}-${String(this.mm.m).padStart(2, "0")}`;
      const rawName = (this.myRow?.hoTen || "nhan_vien")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
        .toLowerCase();
      return `Bao_cao_cham_cong_${rawName || "nhan_vien"}_${ym}.pdf`;
    },

    buildPdfDocDefinition() {
      const nowStr = this.formatDateTime(new Date());
      const todayHuman = this.formatDateHuman(this.now);
      const employeeName = this.myRow?.hoTen || "Nhân viên";
      const dept = this.myRow?.phongBan || "—";
      const monthLabel = this.mmLabel;

      const attendanceSection = this.buildPdfAttendanceSection();
      const statsSection = this.buildPdfStatsSection();
      const ordersSection = this.buildPdfOrdersSection();
      const leavesSection = this.buildPdfLeavesSection();
      const salarySection = this.buildPdfSalarySection();
      const monthGridSection = this.buildPdfMonthGridSection();

      const content = [
        {
          text: "BÁO CÁO CHẤM CÔNG & THU NHẬP CÁ NHÂN",
          style: "header",
          alignment: "center",
          margin: [0, 0, 0, 8],
        },
        {
          columns: [
            [
              { text: `Nhân viên: ${employeeName}`, style: "subHeader" },
              { text: `Phòng ban: ${dept}`, style: "small" },
            ],
            [
              { text: `Tháng: ${monthLabel}`, style: "small", alignment: "right" },
              { text: `In lúc: ${nowStr}`, style: "small", alignment: "right" },
            ],
          ],
          columnGap: 10,
          margin: [0, 0, 0, 10],
        },
        attendanceSection,
        statsSection,
        ordersSection,
        leavesSection,
        salarySection,
        monthGridSection,
      ].filter(Boolean);

      return {
        pageSize: "A4",
        pageMargins: [24, 24, 24, 28],
        defaultStyle: {
          font: "Roboto", // font hỗ trợ tiếng Việt
          fontSize: 9,
        },
        styles: {
          header: { fontSize: 14, bold: true },
          subHeader: { fontSize: 11, bold: true },
          sectionTitle: { fontSize: 11, bold: true, margin: [0, 8, 0, 4] },
          tableHeader: { bold: true, fillColor: "#eeeeee" },
          small: { fontSize: 8 },
        },
        content,
      };
    },

    /* ===== 1. Tổng quan ngày hiện tại + Hoạt động hôm nay ===== */
    buildPdfAttendanceSection() {
      const at = this.attendanceToday || {};
      const firstIn = this.firstCheckIn
        ? this.formatDateTime(this.firstCheckIn)
        : "Chưa có";
      const lastOut = this.lastCheckOut
        ? this.formatDateTime(this.lastCheckOut)
        : "Chưa có";
      const cong = Number(at.soCong ?? 0).toFixed(2);
      const status = this.hasOpenSession ? "Đang làm" : "Đã đóng";
      const workedHours = Number(this.workedHoursToday || 0).toFixed(2);

      const summaryTable = {
        table: {
          widths: ["*", "*"],
          body: [
            [
              { text: "Chấm vào (sớm nhất)", bold: true },
              { text: firstIn },
            ],
            [
              { text: "Chấm ra (muộn nhất)", bold: true },
              { text: lastOut },
            ],
            [
              { text: "Công hôm nay", bold: true },
              { text: `${cong} / 1.00 công` },
            ],
            [
              { text: "Trạng thái", bold: true },
              { text: status },
            ],
            [
              { text: "Giờ làm (ước tính)", bold: true },
              { text: `${workedHours} giờ` },
            ],
          ],
        },
        layout: "lightHorizontalLines",
      };

      const activityBody = [
        [
          {
            text: "Hoạt động hôm nay",
            style: "tableHeader",
            colSpan: 3,
            alignment: "center",
          },
          {},
          {},
        ],
        [
          { text: "Nội dung", style: "tableHeader" },
          { text: "Thời gian", style: "tableHeader" },
          { text: "Ghi chú / Địa điểm", style: "tableHeader" },
        ],
      ];

      const list = this.todayActivityList || [];
      if (list.length) {
        list.forEach((it) => {
          const noteParts = [];
          if (it.extra) noteParts.push(it.extra);
          if (it.diaChi) noteParts.push(it.diaChi);
          activityBody.push([
            it.label || "",
            it.time || "",
            noteParts.join(" — "),
          ]);
        });
      } else {
        activityBody.push([
          {
            text: "Chưa có hoạt động",
            italics: true,
            colSpan: 3,
            alignment: "center",
          },
          {},
          {},
        ]);
      }

      const activityTable = {
        margin: [0, 6, 0, 0],
        table: {
          widths: ["*", 60, "*"],
          body: activityBody,
        },
        layout: "lightHorizontalLines",
      };

      return {
        stack: [
          { text: "1. Tổng quan ngày hiện tại", style: "sectionTitle" },
          summaryTable,
          activityTable,
        ],
      };
    },

    /* ===== 2. Thống kê tháng ===== */
    buildPdfStatsSection() {
      const s = this.stats || {};
      const k = this.kpis || {};
      const todayCong = Number(this.todayCong || 0).toFixed(2);
      const weekCong = Number(this.weekCong || 0).toFixed(2);
      const monthCong = Number(this.monthCong || 0).toFixed(2);
      const todayTarget = Number(this.todayTargetCong || 0).toFixed(2);
      const weekTarget = Number(this.weekTargetCong || 0).toFixed(2);
      const monthTarget = Number(this.monthTargetCong || 0).toFixed(2);

      const sundayCong = Number(s.monthSundayCong ?? 0).toFixed(2);
      const sundayDays = k.sundayDays || 0;
      const sundayTotal = this.monthSundayTotal || 0;

      const ddHours = Number(
        s.dieuDongGio ?? s.monthDieuDongHours ?? k.dieuDongHours ?? 0
      ).toFixed(2);
      const otHours = Number(
        s.tangCaGio ?? s.monthTangCaHours ?? k.overtimeHours ?? 0
      ).toFixed(2);

      const rows = [
        [
          { text: "Công hôm nay", bold: true },
          { text: `${todayCong} / ${todayTarget} công` },
        ],
        [
          { text: "Công tuần", bold: true },
          { text: `${weekCong} / ${weekTarget} công` },
        ],
        [
          { text: "Công tháng", bold: true },
          { text: `${monthCong} / ${monthTarget} công` },
        ],
        [
          { text: "Công Chủ nhật (tháng)", bold: true },
          {
            text: `${sundayCong} công (CN có lệnh: ${sundayDays}/${sundayTotal} ngày)`,
          },
        ],
        [
          { text: "Giờ Điều động (tháng)", bold: true },
          { text: `${ddHours} giờ` },
        ],
        [
          { text: "Giờ Tăng ca (tháng)", bold: true },
          { text: `${otHours} giờ` },
        ],
        [
          { text: "Tổng phút đi sớm", bold: true },
          { text: `${s.monthMinutesVaoSom ?? 0} phút` },
        ],
        [
          { text: "Tổng phút đi trễ", bold: true },
          { text: `${s.monthMinutesVaoTre ?? 0} phút` },
        ],
        [
          { text: "Tổng phút về sớm", bold: true },
          { text: `${s.monthMinutesRaSom ?? 0} phút` },
        ],
        [
          { text: "Số lần quên chấm", bold: true },
          { text: `${s.monthQuenChamCount ?? 0} lần` },
        ],
      ];

      return {
        stack: [
          { text: "2. Thống kê tháng", style: "sectionTitle" },
          {
            table: {
              widths: ["*", "*"],
              body: rows,
            },
            layout: "lightHorizontalLines",
          },
        ],
      };
    },

    /* ===== 3. Lệnh của tôi ===== */
    buildPdfOrdersSection() {
      const parts = [{ text: "3. Lệnh của tôi", style: "sectionTitle" }];

      const makeHeader = () => [
        { text: "Tiêu đề", style: "tableHeader" },
        { text: "Loại / Kiểu", style: "tableHeader" },
        { text: "Thời gian", style: "tableHeader" },
        { text: "Đơn giá", style: "tableHeader" },
        { text: "Cơm", style: "tableHeader" },
        { text: "Xăng", style: "tableHeader" },
      ];

      const buildTimeRange = (l) => {
        const cc = l.chamCong || {};
        const s = cc.effectiveStart || cc.gioVao || l.batDau;
        const e = cc.gioRa || l.ketThuc;
        if (s && e) {
          return `${this.formatDateTime(s)} → ${this.formatDateTime(e)}`;
        }
        if (s) return `${this.formatDateTime(s)} → …`;
        return "—";
      };

      const buildRows = (arr) =>
        arr.map((l) => [
          l.tieuDe || "",
          `${l.loaiLenh || ""} / ${l.kieuThuong || ""}`,
          buildTimeRange(l),
          this.formatMoney(l.tienCong || 0),
          l.hoTroCom ? this.formatMoney(l.hoTroCom) : "—",
          l.hoTroXangXe ? this.formatMoney(l.hoTroXangXe) : "—",
        ]);

      // Pending
      const pending = this.lenh?.pending || [];
      if (pending.length) {
        parts.push({
          text: "3.1 Lệnh chờ xác nhận",
          style: "small",
          margin: [0, 4, 0, 2],
        });
        parts.push({
          table: {
            headerRows: 1,
            widths: ["*", 80, "*", 55, 45, 45],
            body: [makeHeader(), ...buildRows(pending)],
          },
          layout: "lightHorizontalLines",
        });
      }

      // Active
      const active = this.lenh?.active || [];
      if (active.length) {
        parts.push({
          text: "3.2 Lệnh đang thực hiện",
          style: "small",
          margin: [0, 6, 0, 2],
        });
        parts.push({
          table: {
            headerRows: 1,
            widths: ["*", 80, "*", 55, 45, 45],
            body: [makeHeader(), ...buildRows(active)],
          },
          layout: "lightHorizontalLines",
        });
      }

      // Done (trong tháng)
      const doneRows = this.doneMonthRows || [];
      if (doneRows.length) {
        const header = [
          { text: "Ngày", style: "tableHeader" },
          { text: "Tiêu đề", style: "tableHeader" },
          { text: "Loại / Kiểu", style: "tableHeader" },
          { text: "Giờ/Công", style: "tableHeader", alignment: "right" },
          { text: "Cơm", style: "tableHeader", alignment: "right" },
          { text: "Xăng", style: "tableHeader", alignment: "right" },
          { text: "Tiền", style: "tableHeader", alignment: "right" },
        ];
        const body = [header];

        doneRows.forEach((it) => {
          const hoursOrCong =
            it.kieuThuong === "HOURLY"
              ? `${Number(it._hours || 0).toFixed(2)} h`
              : `${Number(it._cong || 0).toFixed(2)} công`;
          body.push([
            this.formatDate(it.pivotDate),
            it.tieuDe || "",
            `${it.loaiLenh || ""} / ${it.kieuThuong || ""}`,
            { text: hoursOrCong, alignment: "right" },
            {
              text:
                it.hoTroCom && it.hoTroCom > 0
                  ? this.formatMoney(it.hoTroCom)
                  : "—",
              alignment: "right",
            },
            {
              text:
                it.hoTroXangXe && it.hoTroXangXe > 0
                  ? this.formatMoney(it.hoTroXangXe)
                  : "—",
              alignment: "right",
            },
            { text: this.formatMoney(it._money || 0), alignment: "right" },
          ]);
        });

        const total = this.doneMonthTotals || {
          totalHours: 0,
          totalCong: 0,
          totalMoney: 0,
        };
        const totalHours = Number(total.totalHours || 0).toFixed(2);
        const totalCong = Number(total.totalCong || 0).toFixed(2);
        const totalMoney = this.formatMoney(total.totalMoney || 0);

        body.push([
          {
            text: "Tổng",
            colSpan: 3,
            alignment: "right",
            bold: true,
          },
          {},
          {},
          {
            text:
              Number(total.totalHours || 0) > 0
                ? `${totalHours} h`
                : `${totalCong} công`,
            alignment: "right",
            bold: true,
          },
          { text: "", alignment: "right" },
          { text: "", alignment: "right" },
          { text: totalMoney, alignment: "right", bold: true },
        ]);

        parts.push({
          text: "3.3 Lệnh hoàn thành trong tháng",
          style: "small",
          margin: [0, 6, 0, 2],
        });
        parts.push({
          table: {
            headerRows: 1,
            widths: [55, "*", 80, 55, 45, 45, 60],
            body,
          },
          layout: "lightHorizontalLines",
        });
      }

      if (!pending.length && !active.length && !doneRows.length) {
        parts.push({
          text: "Hiện chưa có lệnh nào trong kỳ báo cáo.",
          style: "small",
          italics: true,
        });
      }

      return { stack: parts };
    },

    /* ===== 4. Nghỉ phép của tôi ===== */
    buildPdfLeavesSection() {
      const list = (this.leaves && this.leaves.list) || [];
      if (!list.length) {
        return {
          stack: [
            { text: "4. Nghỉ phép của tôi", style: "sectionTitle" },
            {
              text: "Không có đơn nghỉ trong bộ lọc hiện tại.",
              style: "small",
              italics: true,
            },
          ],
        };
      }

      const body = [
        [
          { text: "Mã", style: "tableHeader" },
          { text: "Khoảng ngày", style: "tableHeader" },
          { text: "Đơn vị", style: "tableHeader", alignment: "right" },
          { text: "Trạng thái", style: "tableHeader" },
          { text: "Lý do", style: "tableHeader" },
        ],
      ];

      list.forEach((lv, idx) => {
        const code =
          lv.ma || lv.code || `#${lv.idNghiPhep ?? idx + 1}`;
        const range =
          this.formatDate(lv.tuNgay) +
          (lv.denNgay ? ` → ${this.formatDate(lv.denNgay)}` : "");
        const units = this.calcLeaveUnits(lv);
        body.push([
          code,
          range,
          { text: units != null ? String(units) : "", alignment: "right" },
          this.mapStatus(lv.trangThai),
          lv.lyDo || "",
        ]);
      });

      return {
        stack: [
          { text: "4. Nghỉ phép của tôi", style: "sectionTitle" },
          {
            table: {
              headerRows: 1,
              widths: [50, "*", 40, 60, "*"],
              body,
            },
            layout: "lightHorizontalLines",
          },
        ],
      };
    },

    /* ===== 5. Thu nhập tạm tính ===== */
    buildPdfSalarySection() {
      const data = this.salary?.data;
      if (!data) {
        return {
          stack: [
            { text: "5. Thu nhập tạm tính", style: "sectionTitle" },
            {
              text: "Chưa có dữ liệu thu nhập cho tháng này.",
              style: "small",
              italics: true,
            },
          ],
        };
      }

      const t = this.salaryTotals || {
        com: { now: 0, month: 0 },
        xang: { now: 0, month: 0 },
      };

      const summaryRows = [
        [
          { text: "Ngày chuẩn công ty", bold: true },
          { text: `${data.ngayChuanCty ?? ""}` },
        ],
        [
          { text: "Ngày thực tế đến nay", bold: true },
          {
            text: Number(data.ngayThucTeDenNgay || 0).toFixed(2),
          },
        ],
        [
          { text: "Khoản (CB+PC−KT) đến nay", bold: true },
          { text: this.formatMoney(data.tongThuNhapKhoan_DenNgay || 0) },
        ],
        [
          { text: "Thu nhập từ Lệnh đến nay", bold: true },
          { text: this.formatMoney(data.thuNhapLenh_DenNgay || 0) },
        ],
        [
          { text: "TẠM TÍNH đến nay", bold: true },
          { text: this.formatMoney(data.tamTinhDenNgay || 0) },
        ],
        [
          { text: "ƯỚC TÍNH cuối tháng", bold: true },
          { text: this.formatMoney(data.duKienCuoiThang || 0) },
        ],
      ];

      if (t.com.now > 0) {
        summaryRows.splice(3, 0, [
          { text: "Hỗ trợ cơm đến nay", bold: true },
          {
            text:
              this.formatMoney(t.com.now) +
              (t.com.month && t.com.month !== t.com.now
                ? ` (ước cả tháng: ${this.formatMoney(t.com.month)})`
                : ""),
          },
        ]);
      }
      if (t.xang.now > 0) {
        summaryRows.splice(3, 0, [
          { text: "Hỗ trợ xăng đến nay", bold: true },
          {
            text:
              this.formatMoney(t.xang.now) +
              (t.xang.month && t.xang.month !== t.xang.now
                ? ` (ước cả tháng: ${this.formatMoney(t.xang.month)})`
                : ""),
          },
        ]);
      }

      const summaryTable = {
        table: {
          widths: ["*", "*"],
          body: summaryRows,
        },
        layout: "lightHorizontalLines",
      };

      const items = data.items || [];
      const detailBody = [
        [
          { text: "Tên khoản", style: "tableHeader" },
          { text: "Loại", style: "tableHeader" },
          { text: "Cách tính", style: "tableHeader" },
          { text: "Giá trị", style: "tableHeader", alignment: "right" },
          { text: "Thực lãnh", style: "tableHeader", alignment: "right" },
          { text: "Ước tính", style: "tableHeader", alignment: "right" },
        ],
      ];

      if (items.length) {
        items.forEach((it) => {
          const loai = (it.loai || "").toUpperCase();
          let loaiLabel = loai;
          if (loai === "CO_BAN") loaiLabel = "Cơ bản";
          if (loai === "PHU_CAP") loaiLabel = "Phụ cấp";
          if (loai === "KHAU_TRU") loaiLabel = "Khấu trừ";

          detailBody.push([
            it.tenKhoang || "",
            loaiLabel,
            it.phuongThuc || "",
            {
              text: this.formatMoney(it.giaTriThang || 0),
              alignment: "right",
            },
            {
              text: this.formatMoney(it.soTienDenNgay || 0),
              alignment: "right",
            },
            {
              text: this.formatMoney(it.soTienUocTinhThang || 0),
              alignment: "right",
            },
          ]);
        });
      } else {
        detailBody.push([
          {
            text: "Không có cấu hình khoản.",
            colSpan: 6,
            alignment: "center",
            italics: true,
          },
          {},
          {},
          {},
          {},
          {},
        ]);
      }

      const detailTable = {
        margin: [0, 6, 0, 0],
        table: {
          headerRows: 1,
          widths: ["*", 55, 55, 55, 55, 55],
          body: detailBody,
        },
        layout: "lightHorizontalLines",
      };

      return {
        stack: [
          { text: "5. Thu nhập tạm tính", style: "sectionTitle" },
          summaryTable,
          detailTable,
        ],
      };
    },

    /* ===== 6. Lịch công tháng (tóm tắt) ===== */
    buildPdfMonthGridSection() {
      const row = this.myRow;
      if (!row || !Array.isArray(row.daily) || !row.daily.length) {
        return null;
      }

      const body = [
        [
          { text: "Ngày", style: "tableHeader" },
          { text: "Công", style: "tableHeader", alignment: "right" },
          { text: "Vào trễ", style: "tableHeader", alignment: "right" },
          { text: "Vào sớm", style: "tableHeader", alignment: "right" },
          { text: "Ra sớm", style: "tableHeader", alignment: "right" },
          { text: "Quên chấm", style: "tableHeader", alignment: "right" },
          { text: "Nghỉ phép", style: "tableHeader" },
          { text: "Lệnh", style: "tableHeader", alignment: "right" },
        ],
      ];

      row.daily.forEach((c) => {
        if (!c) return;
        const day = c.day || "";
        const cong =
          c.congNgay != null
            ? Number(c.congNgay || 0).toFixed(2)
            : "";
        const vaoTre = c.tongVaoTre || 0;
        const vaoSom = c.tongVaoSom || 0;
        const raSom = c.tongRaSom || 0;
        const quen = c.tongQuenCham || 0;
        const lenh = c.soLenhHoanThanh || 0;

        let leaveTxt = "";
        if (c.coNghiPhep) {
          if (c.nghiPhepFull || (c.nghiPhepAm && c.nghiPhepPm)) {
            leaveTxt = "Cả ngày";
          } else if (c.nghiPhepAm && !c.nghiPhepPm) {
            leaveTxt = "Buổi sáng";
          } else if (c.nghiPhepPm && !c.nghiPhepAm) {
            leaveTxt = "Buổi chiều";
          } else {
            leaveTxt = "Có phép";
          }
        }

        body.push([
          String(day),
          { text: cong, alignment: "right" },
          { text: String(vaoTre), alignment: "right" },
          { text: String(vaoSom), alignment: "right" },
          { text: String(raSom), alignment: "right" },
          { text: String(quen), alignment: "right" },
          leaveTxt,
          { text: String(lenh), alignment: "right" },
        ]);
      });

      const totalCong =
        row.totalCong != null
          ? Number(row.totalCong || 0).toFixed(2)
          : "";

      body.push([
        {
          text: "Tổng công tháng",
          colSpan: 2,
          alignment: "right",
          bold: true,
        },
        {},
        { text: totalCong, alignment: "right", bold: true },
        {},
        {},
        {},
        {},
        {},
      ]);

      return {
        pageBreak: "before",
        stack: [
          { text: "6. Lịch công tháng (tóm tắt)", style: "sectionTitle" },
          {
            table: {
              headerRows: 1,
              widths: ["auto", 40, 35, 35, 35, 40, "*", 30],
              body,
            },
            layout: "lightHorizontalLines",
          },
        ],
      };
    },

    /* ===== Helpers ===== */
    normalizeLenhItem(raw) {
      if (!raw) return null;

      const base = raw.lenh || raw;

      const res = {
        idLenh: base.idLenh ?? base.id ?? raw.idLenh ?? raw.id ?? null,
        tieuDe: base.tieuDe ?? raw.tieuDe ?? "",
        moTa: base.moTa ?? raw.moTa ?? "",
        loaiLenh: base.loaiLenh ?? raw.loaiLenh ?? "",
        kieuThuong: base.kieuThuong ?? raw.kieuThuong ?? "",
        batDau: base.batDau ?? raw.batDau ?? null,
        ketThuc: base.ketThuc ?? raw.ketThuc ?? null,
        tienCong: base.tienCong ?? raw.tienCong ?? 0,
        trangThai: base.trangThai ?? raw.trangThai ?? "",
        // === NEW: hỗ trợ cơm / xăng nếu backend có trả về ===
        hoTroCom: base.hoTroCom ?? raw.hoTroCom ?? 0,
        hoTroXangXe: base.hoTroXangXe ?? raw.hoTroXangXe ?? 0,
      };


      let cc =
        raw.chamCong ||
        raw.myChamCong ||
        raw.chamCongNhanVien ||
        raw.chamCongDto ||
        base.chamCong ||
        (Array.isArray(raw.chamCongList) ? raw.chamCongList[0] : null) ||
        (Array.isArray(base.chamCongList) ? base.chamCongList[0] : null);

      if (cc) {
        res.chamCong = { ...cc };
      }

      ["qlStartAt", "qlStartAnhUrl", "qlStartDiaDiemText",
        "qlEndAt", "qlEndAnhUrl", "qlEndDiaDiemText"].forEach(k => {
          if (base[k] != null) res[k] = base[k];
          else if (raw[k] != null) res[k] = raw[k];
        });

      return res;
    },

    tickNow() { this._tickInt = setInterval(() => (this.now = new Date()), 30000); },
    formatDateHuman(dt) { const d = new Date(dt); return d.toLocaleDateString("vi-VN", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" }); },
    formatDateTime(dt) { return new Date(dt).toLocaleString("vi-VN", { hour12: false }); },
    formatTime(dt) { return new Date(dt).toLocaleTimeString("vi-VN", { hour12: false, hour: "2-digit", minute: "2-digit" }); },
    // Nếu chuỗi là YYYY-MM-DD thì parse local để tránh lệch ngày
    formatDate(d) {
      if (!d) return "—";
      if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
        const dd = this.parseYmd(d);
        return dd.toLocaleDateString("vi-VN");
      }
      return new Date(d).toLocaleDateString("vi-VN");
    },
    formatMoney(v) { return Number(v || 0).toLocaleString("vi-VN") + " đ"; },
    pct(a, b) { const x = Number(a ?? 0), y = Number(b ?? 0) || 1; return Math.max(0, Math.min(100, Math.round((x / y) * 100))); },
    clamp100(v) { return Math.max(0, Math.min(100, Math.round(Number(v || 0)))); },
    initials(name) { const n = (name || "").trim().split(/\s+/); return (n[0]?.[0] || "") + (n[n.length - 1]?.[0] || ""); },

    // ==== DATE HELPERS (LOCAL, TZ-SAFE) ====
    toLocalYmd(d) {
      const yy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yy}-${mm}-${dd}`;
    },
    parseYmd(ymd) {
      const [y, m, d] = ymd.split("-").map(Number);
      return new Date(y, (m || 1) - 1, d || 1, 0, 0, 0, 0);
    },
    startOfDayYmd(ymd) {
      const [y, m, d] = ymd.split("-").map(Number);
      return new Date(y, (m || 1) - 1, d || 1, 0, 0, 0, 0);
    },
    endOfDayYmd(ymd) {
      const [y, m, d] = ymd.split("-").map(Number);
      return new Date(y, (m || 1) - 1, d || 1, 23, 59, 59, 999);
    },

    monthEndStr(y, m) { const last = new Date(y, m, 0); return this.toLocalYmd(last); },
    todayStr() { return this.toLocalYmd(new Date()); },

    /* ===== Salary Preview ===== */
    async fetchSalaryPreview() {
      try {
        this.salary.loading = true;
        const ym = `${this.mm.y}-${String(this.mm.m).padStart(2, '0')}`;
        const now = new Date();
        const isCurrent = (this.mm.y === now.getFullYear() && this.mm.m === (now.getMonth() + 1));
        const asOf = isCurrent ? this.todayStr() : this.monthEndStr(this.mm.y, this.mm.m);
        const { data } = await api.get("/api/payroll/my/preview", { params: { month: ym, asOf } });
        this.salary.data = data?.data || null;
      } catch {
        this.salary.data = null;
      } finally { this.salary.loading = false; }
    },

    onPickMonth(e) {
      try {
        const v = e?.target?.value; // yyyy-mm
        if (!v || !/^\d{4}-\d{2}$/.test(v)) return;
        const y = Number(v.slice(0, 4));
        const m = Number(v.slice(5, 7));
        this.mm.y = y; this.mm.m = m;

        this.setDoneMonthRange();
        this.fetchMyMonth();
        this.fetchSalaryPreview();
        this.fetchHistoryThisMonth();
        this.recomputeLenhKpis();
      } catch { }
    },

    /* ===== Fetch Attendance ===== */
    async fetchToday() {
      this.loadingAttendance = true;
      try {
        const { data } = await api.get("/api/cham-cong/my/today");
        this.attendanceToday = data?.data || null;
      } catch { this.attendanceToday = null; }
      finally { this.loadingAttendance = false; }
    },
    async fetchStats() {
      try {
        const today = this.todayStr();
        const { data } = await api.get("/api/cham-cong/my/stats", { params: { today } });
        this.stats = data?.data || {};
      } catch { this.stats = {}; }
    },
    async fetchHistoryThisMonth() {
      try {
        const now = new Date();
        const y = this.mm.y; const m = String(this.mm.m).padStart(2, "0");
        const d = (y === now.getFullYear() && this.mm.m === (now.getMonth() + 1))
          ? String(now.getDate()).padStart(2, "0")
          : String(new Date(y, this.mm.m, 0).getDate()).padStart(2, "0");
        const from = `${y}-${m}-01`; const to = `${y}-${m}-${d}`;
        const { data } = await api.get("/api/cham-cong/my/history", { params: { from, to } });
        this.historyRows = data?.data || [];
      } catch { this.historyRows = []; }
    },

    /* ===== Fetch Orders (LỆNH) ===== */
    async fetchMyLenh() {
      this.lenh.loading = true;
      try {
        const [p, a] = await Promise.all([
          api.get("/api/lenh/my", { params: { status: "PENDING" } }),
          api.get("/api/lenh/my", { params: { status: "ACCEPTED" } }),
        ]);

        const pendingRaw = p?.data?.data || [];
        const acceptedRaw = a?.data?.data || [];

        const pending = pendingRaw
          .map(x => this.normalizeLenhItem(x))
          .filter(Boolean);
        const accepted = acceptedRaw
          .map(x => this.normalizeLenhItem(x))
          .filter(Boolean);

        const active = [];
        const done = [];

        accepted.forEach(l => {
          const cc = l.chamCong || {};
          if (cc.gioVao && cc.gioRa) {
            done.push(l);
          } else {
            active.push(l);
          }
        });

        this.lenh.pending = pending;
        this.lenh.active = active;
        this.lenh.done = done;

        this.pendingPager.number = 0;
        this.activePager.number = 0;
        this.pageDone.number = 0;
        this.doneMonthPager.number = 0;
      } catch (e) {
        console.error(e);
        this.lenh.pending = [];
        this.lenh.active = [];
        this.lenh.done = [];
      } finally {
        this.lenh.loading = false;
        this.recomputeLenhKpis();
      }
    },

    /* ===== Month grid ===== */
    async fetchMyMonth() {
      try {
        this.mm.loading = true;
        const month = `${this.mm.y}-${String(this.mm.m).padStart(2, '0')}`;
        const { data } = await api.get("/api/cham-cong/my/month-grid", { params: { month } });
        this.myMonth = data?.data || null;
      } catch { this.myMonth = null; }
      finally { this.mm.loading = false; }
    },
    prevMonth() {
      let y = this.mm.y, m = this.mm.m - 1;
      if (m < 1) { m = 12; y--; }
      this.mm.y = y; this.mm.m = m;

      this.setDoneMonthRange();
      this.fetchMyMonth();
      this.fetchSalaryPreview();
      this.fetchHistoryThisMonth();
      this.recomputeLenhKpis();
    },
    nextMonth() {
      let y = this.mm.y, m = this.mm.m + 1;
      if (m > 12) { m = 1; y++; }
      this.mm.y = y; this.mm.m = m;

      this.setDoneMonthRange();
      this.fetchMyMonth();
      this.fetchSalaryPreview();
      this.fetchHistoryThisMonth();
      this.recomputeLenhKpis();
    },
    iconHalf(c, half) {
      const isInRow = half === 'AM';

      // 1) Ngày lễ ghi đè hết
      if (c.holiday) {
        return 'fa fa-gift text-danger';
      }

      // 2) Nghỉ phép cả ngày
      const leaveFull = c.coNghiPhep &&
        (c.nghiPhepFull || (c.nghiPhepAm && c.nghiPhepPm));
      if (leaveFull) {
        return 'fa fa-calendar-check-o text-info';
      }

      const vaoTre = Number(c.tongVaoTre || 0);
      const vaoSom = Number(c.tongVaoSom || 0);
      const raSom = Number(c.tongRaSom || 0);
      const quen = Number(c.tongQuenCham || 0) > 0;
      const openAny = !!(c.amOpen || c.pmOpen || c.open);
      const hasWork = Number(c.congNgay || 0) > 0 ||
        !!c.amPresent || !!c.pmPresent;

      if (isInRow) {
        // Hàng 1: VÀO
        if (!hasWork && vaoTre <= 0 && vaoSom <= 0) {
          return 'fa fa-times text-danger';
        }
        if (vaoTre > 0) return 'fa fa-sign-in text-danger';
        if (vaoSom > 0) return 'fa fa-sign-in text-info';
        if (hasWork) return 'fa fa-sign-in text-success';
        return 'fa fa-sign-in text-muted';
      } else {
        // Hàng 2: RA
        if (openAny) return 'fa fa-clock-o text-warning';
        if (quen) return 'fa fa-exclamation-circle text-danger';
        if (raSom > 0) return 'fa fa-sign-out text-warning';
        if (!hasWork) return 'fa fa-times text-danger';
        return 'fa fa-sign-out text-success';
      }
    },
    hasPartialLeave(c) {
      if (!c || !c.coNghiPhep) return false;
      const am = !!c.nghiPhepAm;
      const pm = !!c.nghiPhepPm;
      const full = !!c.nghiPhepFull || (am && pm);
      return !full && (am || pm);
    },
    leaveSummary(c) {
      if (!c || !c.coNghiPhep) return '';
      const am = !!c.nghiPhepAm;
      const pm = !!c.nghiPhepPm;
      const full = !!c.nghiPhepFull || (am && pm);
      if (full) return 'Nghỉ phép cả ngày';
      if (am && !pm) return 'Nghỉ phép buổi sáng';
      if (pm && !am) return 'Nghỉ phép buổi chiều';
      return 'Có nghỉ phép';
    },

    iconBuoi(c, half, io) {
      const isAm = half === 'AM';

      const vaoTre = isAm ? (c.amVaoTre || 0) : (c.pmVaoTre || 0);
      const vaoSom = isAm ? (c.amVaoSom || 0) : (c.pmVaoSom || 0);
      const raSom = isAm ? (c.amRaSom || 0) : (c.pmRaSom || 0);
      const open = isAm ? !!c.amOpen : !!c.pmOpen;
      const present = isAm ? !!c.amPresent : !!c.pmPresent;
      const quen = isAm ? !!c.amQuenCham : !!c.pmQuenCham;

      // 1) GHI ĐÈ bởi NGÀY LỄ
      if (c.holiday) {
        return 'fa fa-gift text-danger';
      }

      // 2) GHI ĐÈ bởi NGHỈ PHÉP
      const hasLeaveThisHalf =
        c.coNghiPhep &&
        (c.nghiPhepFull || (isAm ? c.nghiPhepAm : c.nghiPhepPm));

      if (hasLeaveThisHalf) {
        return 'fa fa-calendar-check-o text-info';
      }

      // 3) Logic IN / OUT theo giờ
      if (io === 'IN') {
        if (vaoTre > 0) return 'fa fa-sign-in text-danger';
        if (vaoSom > 0) return 'fa fa-sign-in text-info';
        if (present || open) return 'fa fa-sign-in text-success';
        return 'fa fa-sign-in text-muted';
      } else {
        if (open) return 'fa fa-clock-o text-warning';
        if (quen) return 'fa fa-exclamation-circle text-danger';
        if (raSom > 0) return 'fa fa-sign-out text-warning';
        if (present) return 'fa fa-sign-out text-success';
        return 'fa fa-sign-out text-muted';
      }
    },

    dayCellClasses(c) {
      return {
        'sunday-cell': c.sunday,
        'holiday-cell': c.holiday,
        'leave-cell': c.coNghiPhep
      };
    },
    cellTooltip(c) {
      if (!c) return '';

      const parts = [];
      if (c.congNgay != null) {
        parts.push(`Công: ${Number(c.congNgay || 0).toFixed(2)}`);
      }
      if (c.tongVaoTre) {
        parts.push(`Vào trễ: ${c.tongVaoTre} phút`);
      }
      if (c.tongVaoSom) {
        parts.push(`Vào sớm: ${c.tongVaoSom} phút`);
      }
      if (c.tongRaSom) {
        parts.push(`Ra sớm: ${c.tongRaSom} phút`);
      }
      if (c.tongQuenCham) {
        parts.push(`Quên chấm: ${c.tongQuenCham} lần`);
      }
      if (c.soLenhHoanThanh) {
        parts.push(`Lệnh: ${c.soLenhHoanThanh}`);
      }
      if (c.coNghiPhep) {
        let txt = 'Có nghỉ phép';
        if (c.nghiPhepFull) txt += ' (cả ngày)';
        else if (c.nghiPhepAm && c.nghiPhepPm) txt += ' (sáng + chiều)';
        else if (c.nghiPhepAm) txt += ' (sáng)';
        else if (c.nghiPhepPm) txt += ' (chiều)';
        parts.push(txt);
      }
      if (c.holiday) {
        parts.push('Nghỉ lễ');
      }

      return parts.join(' | ');
    },

    /* ====== ICON LỆNH TRÊN Ô LƯỚI ====== */
    ordersCountForCell(cell) {
      const date = `${this.mm.y}-${String(this.mm.m).padStart(2, '0')}-${String(cell.day).padStart(2, '0')}`;
      return (this.ordersByDate[date] || []).length;
    },
    orderFlagForCell(cell) {
      const date = `${this.mm.y}-${String(this.mm.m).padStart(2, '0')}-${String(cell.day).padStart(2, '0')}`;
      const list = this.ordersByDate[date] || [];
      const count = list.length;
      let icon = 'fa fa-briefcase';
      let variant = 'order-flag--default';
      const has = (t) => list.some(x => (x.loaiLenh || '').toUpperCase() === t);
      if (has('TANG_CA')) { icon = 'fa fa-bolt'; variant = 'order-flag--ot'; }
      else if (has('DIEU_DONG')) { icon = 'fa fa-random'; variant = 'order-flag--dd'; }
      else if (has('CHU_NHAT')) { icon = 'fa fa-calendar'; variant = 'order-flag--sun'; }
      const types = Array.from(new Set(list.map(x => (x.loaiLenh || '').toUpperCase()).filter(Boolean)));
      const title = `Có ${count} lệnh: ${types.join(', ')}`;
      return { count, icon, variant, title };
    },
    orderIconByLoai(loai) {
      const t = (loai || '').toUpperCase();
      if (t === 'TANG_CA') return { icon: 'fa fa-bolt text-warning', title: 'Tăng ca' };
      if (t === 'DIEU_DONG') return { icon: 'fa fa-random text-info', title: 'Điều động' };
      if (t === 'CHU_NHAT') return { icon: 'fa fa-calendar text-success', title: 'Chủ nhật' };
      return { icon: 'fa fa-briefcase text-primary', title: 'Lệnh' };
    },
    itTimeRange(l) {
      const cc = l.chamCong || {};
      const s = cc.effectiveStart || cc.gioVao || l.batDau;
      const e = cc.gioRa || l.ketThuc;
      if (s && e) return `${this.formatTime(s)} → ${this.formatTime(e)}`;
      if (s) return `${this.formatTime(s)} → …`;
      return '—';
    },

    openMyDay(cell) {
      const date = `${this.mm.y}-${String(this.mm.m).padStart(2, '0')}-${String(cell.day).padStart(2, '0')}`;
      this.dayModal = { open: true, date, detail: null };
      this.fetchMyDayDetail(date);
    },
    async fetchMyDayDetail(date) {
      try {
        const { data } = await api.get("/api/cham-cong/my", { params: { date } });
        this.dayModal.detail = data?.data || { ngay: date, soCong: 0, chiTietBuoi: [] };
      } catch {
        this.dayModal.detail = { ngay: date, soCong: 0, chiTietBuoi: [] };
      }
    },
    closeDayModal() { this.dayModal.open = false; },

    /* ===== KPI từ LỆNH trong tháng ===== */
    recomputeLenhKpis() {
      try {
        const y = this.mm.y;
        const m = this.mm.m;
        const start = new Date(y, m - 1, 1, 0, 0, 0);
        const end = new Date(y, m, 0, 23, 59, 59);

        const inMonth = (dt) => {
          if (!dt) return false;
          const d = new Date(dt);
          return d >= start && d <= end;
        };

        const all = [...(this.lenh.active || []), ...(this.lenh.done || [])];

        const sundaySet = new Set();
        let ot = 0, dd = 0;

        for (const l of all) {
          const loai = (l.loaiLenh || '').toUpperCase();
          const kieu = (l.kieuThuong || '').toUpperCase();

          const cc = l.chamCong || {};
          const startEff = cc.effectiveStart ? new Date(cc.effectiveStart)
            : (cc.gioVao ? new Date(cc.gioVao)
              : (l.batDau ? new Date(l.batDau) : null));
          const endEff = cc.gioRa ? new Date(cc.gioRa)
            : (l.ketThuc ? new Date(l.ketThuc) : null);

          if (startEff && inMonth(startEff) && startEff.getDay() === 0) {
            sundaySet.add(this.toLocalYmd(startEff));
          }

          let hours = Number(cc.soGioThuong ?? 0);
          if (!hours && startEff && endEff) {
            hours = Math.max(0, (endEff - startEff) / 36e5);
          }

          if (startEff && inMonth(startEff)) {
            if (loai === 'TANG_CA' && kieu === 'HOURLY') ot += hours;
            if (loai === 'DIEU_DONG' && kieu === 'HOURLY') dd += hours;
          }
        }

        this.kpis = {
          sundayDays: sundaySet.size,
          overtimeHours: ot,
          dieuDongHours: dd,
        };
      } catch {
        this.kpis = { sundayDays: 0, overtimeHours: 0, dieuDongHours: 0 };
      }
    },

    /* ===== CAMERA + Upload ảnh (có XÁC NHẬN) ===== */
    async openCamera(kind, lenhId = null) {
      try {
        if (!navigator.mediaDevices?.getUserMedia) throw new Error("Thiếu API camera");
        this.camera.open = true; this.camera.for = kind; this.camera.lenhId = lenhId; this.camera.loading = true;
        this.camera.deviceLabel = ''; this.prepareGeo();
        this.camera.step = 'live'; this.camera.previewUrl = null; this.camera.blob = null;

        const preferFacing = kind.startsWith('lenh') ? 'environment' : 'user';
        this.camera.lastFacing = preferFacing;

        await this.startStreamByFacing(preferFacing);
        await this.initDevices(preferFacing);

        this.$nextTick(() => this.enterFullscreen());
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Không mở được camera', text: 'Vui lòng cấp quyền camera (HTTPS) và thử lại.' });
        this.stopCamera();
      } finally { this.camera.loading = false; }
    },
    async initDevices(preferFacing = 'user') {
      try {
        const devs = await navigator.mediaDevices.enumerateDevices();
        const videos = devs.filter(d => d.kind === 'videoinput');
        this.camera.devices = videos;

        let idx = 0;
        if (videos.length > 1) {
          const backIdx = videos.findIndex(d => /back|rear|environment/i.test(d.label));
          const frontIdx = videos.findIndex(d => /front|user|face|webcam/i.test(d.label));
          if (preferFacing === 'environment' && backIdx >= 0) idx = backIdx;
          else if (preferFacing === 'user' && frontIdx >= 0) idx = frontIdx;
        }
        this.camera.deviceIndex = idx;
        this.camera.deviceLabel = videos[idx]?.label || '';
      } catch { this.camera.devices = []; this.camera.deviceLabel = ''; }
    },
    async startStreamByFacing(facing = 'user') { await this.startStream({ video: { facingMode: { ideal: facing }, width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false }); },
    async startStreamByDeviceId(deviceId) { await this.startStream({ video: { deviceId: { exact: deviceId }, width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false }); },
    async startStream(constraints) {
      this.stopCameraStreamOnly();
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.camera.stream = stream;
      this.$nextTick(async () => {
        const video = this.$refs.videoRef;
        if (video) { video.srcObject = stream; await video.play().catch(() => { }); }
      });
    },
    async switchCamera() {
      try {
        this.camera.loading = true;
        if (this.camera.step !== 'live') return;
        const vs = this.camera.devices;
        if (vs.length > 1) {
          this.camera.deviceIndex = (this.camera.deviceIndex + 1) % vs.length;
          const dev = vs[this.camera.deviceIndex];
          this.camera.deviceLabel = dev?.label || '';
          await this.startStreamByDeviceId(dev.deviceId);
        } else {
          this.camera.lastFacing = this.camera.lastFacing === 'user' ? 'environment' : 'user';
          await this.startStreamByFacing(this.camera.lastFacing);
        }
      } finally { this.camera.loading = false; }
    },
    stopCameraStreamOnly() { try { if (this.camera.stream) this.camera.stream.getTracks().forEach(t => t.stop()); } catch { } this.camera.stream = null; },

    enterFullscreen() {
      try {
        const el = this.$refs.cameraModalRef;
        if (el && el.requestFullscreen) el.requestFullscreen().catch(() => { });
      } catch { }
    },
    exitFullscreen() {
      try {
        if (document.fullscreenElement && document.exitFullscreen) {
          document.exitFullscreen().catch(() => { });
        }
      } catch { }
    },

    stopCamera() {
      this.exitFullscreen();
      this.stopCameraStreamOnly();
      if (this.camera.previewUrl) URL.revokeObjectURL(this.camera.previewUrl);
      this.camera.open = false; this.camera.for = null; this.camera.lenhId = null;
      this.camera.devices = []; this.camera.deviceLabel = '';
      this.camera.geo = { ready: false, lat: null, lng: null, address: '' };
      this.camera.step = 'live'; this.camera.previewUrl = null; this.camera.blob = null;
    },
    closeCamera() { this.stopCamera(); },

    async capture() {
      try {
        const video = this.$refs.videoRef, canvas = this.$refs.canvasRef;
        if (!video || !canvas) throw new Error("Thiếu phần tử camera");

        for (let i = 0; i < 10 && (!video.videoWidth || !video.videoHeight); i++) await new Promise(r => setTimeout(r, 120));

        const w = video.videoWidth || 1920, h = video.videoHeight || 1080;
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, w, h);

        const { lat, lng, address } = await this.getGeoReady();
        await this.drawWatermarkLikeSample(ctx, w, h, {
          logo: this._wmLogo,
          when: new Date(),
          address: address || (lat != null && lng != null ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : "")
        });

        const blob = await new Promise(res => canvas.toBlob(res, "image/jpeg", 0.92));
        if (!blob) throw new Error("Không chụp được ảnh");
        if (this.camera.previewUrl) URL.revokeObjectURL(this.camera.previewUrl);
        this.camera.blob = blob;
        this.camera.previewUrl = URL.createObjectURL(blob);
        this.camera.step = 'confirm';
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'Chụp thất bại', text: e?.message || 'Vui lòng thử lại.' });
      }
    },

    async sendCaptured() {
      if (!this.camera.blob) return;
      this.punching = true;
      try {
        const file = new File([this.camera.blob], `att_${Date.now()}.jpg`, { type: "image/jpeg" });
        const formData = new FormData();
        formData.append("files", file);
        formData.append("folderName", this.camera.for?.startsWith("lenh") ? "lenh" : "attendance");

        const up = await api.post("/api/images/upload", formData, { headers: { "Content-Type": "multipart/form-data" } });

        const fileUrl =
          up?.data?.[0]?.location ||
          up?.data?.data?.[0]?.location ||
          up?.data?.location ||
          up?.data?.data?.location;
        if (!fileUrl) throw new Error("Upload ảnh thất bại");

        const { lat, lng, address } = await this.getGeoReady();
        const payload = {
          diaDiemText: address || (lat != null && lng != null ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : null),
          lat, lng, anhUrl: fileUrl
        };

        if (this.camera.for === "attendance-in") {
          await api.post("/api/cham-cong/check-in", payload);
          this.toastSuccess("Chấm vào thành công");
        } else if (this.camera.for === "attendance-out") {
          await api.post("/api/cham-cong/check-out", payload);
          this.toastSuccess("Chấm ra thành công");
        } else if (this.camera.for === "lenh-in") {
          await api.post(`/api/lenh/${this.camera.lenhId}/check-in`, payload);
          this.toastSuccess("Check-in lệnh thành công");
        } else if (this.camera.for === "lenh-out") {
          await api.post(`/api/lenh/${this.camera.lenhId}/check-out`, payload);
          this.toastSuccess("Check-out lệnh thành công");
        }

        this.closeCamera();

        this.$nextTick(() => {
          Promise.allSettled([
            this.fetchToday(), this.fetchStats(), this.fetchHistoryThisMonth(),
            this.fetchMyLenh(), this.fetchMyMonth(), this.fetchSalaryPreview()
          ]);
        });
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Thao tác thất bại', text: (err?.response?.data?.message || err.message || 'Có lỗi xảy ra') });
      } finally {
        this.punching = false;
      }
    },

    retake() {
      if (this.camera.previewUrl) URL.revokeObjectURL(this.camera.previewUrl);
      this.camera.previewUrl = null;
      this.camera.blob = null;
      this.camera.step = 'live';
    },

    /* ===== Watermark helpers ===== */
    async drawWatermarkLikeSample(ctx, w, h, opts = {}) {
      const logo = opts.logo || null;
      const when = opts.when instanceof Date ? opts.when : new Date();
      const addr = (opts.address || "").toString();

      const base = Math.max(w, h);
      const pad = Math.max(12, Math.round(base * 0.012));
      const timeFontPx = Math.max(44, Math.round(base * 0.05));
      const dateFontPx = Math.max(18, Math.round(base * 0.02));
      const addrFontPx = Math.max(14, Math.round(base * 0.017));
      const logoSize = Math.max(64, Math.round(base * 0.08));

      const extraAddr = addr ? addrFontPx + Math.round(pad * 0.2) : 0;
      const textTotalH = timeFontPx + dateFontPx + dateFontPx + extraAddr;
      const groupH = Math.max(logoSize, textTotalH);

      const top = h - pad - groupH;
      const left = pad;

      if (logo && (logo.complete || logo.decode)) {
        try { if (logo.decode) await logo.decode(); } catch { }
        const lx = left;
        const ly = top + Math.round((groupH - logoSize) / 2);
        ctx.save();
        this._roundedRect(ctx, lx, ly, logoSize, logoSize, 10);
        ctx.clip();
        ctx.drawImage(logo, lx, ly, logoSize, logoSize);
        ctx.restore();
      }

      const tx = left + logoSize + pad;
      let ty = top;

      const hh = String(when.getHours()).padStart(2, "0");
      const mm = String(when.getMinutes()).padStart(2, "0");
      const vn = this._formatVnDate(when);

      ctx.save();
      ctx.fillStyle = "#fff";
      ctx.textBaseline = "top";
      ctx.shadowColor = "rgba(0,0,0,0.6)";
      ctx.shadowBlur = Math.max(6, Math.round(base * 0.012));
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = Math.max(2, Math.round(base * 0.003));

      ctx.font = `700 ${timeFontPx}px sans-serif`;
      ctx.fillText(`${hh}:${mm}`, tx, ty);
      ty += timeFontPx + Math.round(pad * 0.2);

      ctx.font = `600 ${dateFontPx}px sans-serif`;
      ctx.fillText(vn.dateLine, tx, ty);
      ty += dateFontPx + Math.round(pad * 0.1);

      ctx.font = `500 ${dateFontPx}px sans-serif`;
      ctx.fillText(vn.weekday, tx, ty);
      ty += dateFontPx + Math.round(pad * 0.1);

      if (addr) {
        ctx.font = `400 ${addrFontPx}px sans-serif`;
        ctx.fillText(addr, tx, ty);
      }
      ctx.restore();
    },

    _roundedRect(ctx, x, y, w, h, r) {
      const rr = Math.min(r, w / 2, h / 2);
      ctx.beginPath();
      ctx.moveTo(x + rr, y);
      ctx.arcTo(x + w, y, x + w, y + h, rr);
      ctx.arcTo(x + w, y + h, x, y + h, rr);
      ctx.arcTo(x, y + h, x, y, rr);
      ctx.arcTo(x, y, x + w, y, rr);
      ctx.closePath();
    },
    _formatVnDate(d) {
      const day = String(d.getDate()).padStart(2, '0');
      const month = d.getMonth() + 1;
      const year = d.getFullYear();
      const weekdays = ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"];
      return { dateLine: `${day} Tháng ${month}, ${year}`, weekday: weekdays[d.getDay()] };
    },

    /* ===== GEO ===== */
    prepareGeo() {
      this.camera.geo = { ready: false, lat: null, lng: null, address: '' };
      if (!navigator.geolocation) { this.camera.geo.ready = true; return; }
      navigator.geolocation.getCurrentPosition(async (pos) => {
        const lat = pos.coords.latitude, lng = pos.coords.longitude;
        this.camera.geo.lat = lat; this.camera.geo.lng = lng;
        try { this.camera.geo.address = await this.reverseGeocode(lat, lng); }
        catch { this.camera.geo.address = ""; }
        this.camera.geo.ready = true;
      }, () => { this.camera.geo.ready = true; }, { enableHighAccuracy: true, timeout: 12000, maximumAge: 30000 });
    },
    async getGeoReady() {
      if (!this.camera.geo.ready) await new Promise(r => setTimeout(r, 3000));
      return { lat: this.camera.geo.lat, lng: this.camera.geo.lng, address: this.camera.geo.address };
    },
    async reverseGeocode(lat, lng) {
      try {
        if (lat == null || lng == null) return null;
        const u = `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lng}&lang=vi&apiKey=${GEOAPIFY_KEY}`;
        const res = await fetch(u); const json = await res.json(); const f = json?.features?.[0];
        return f?.properties?.formatted || `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      } catch { return lat && lng ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : null; }
    },

    /* ===== Orders actions ===== */
    handlePunch() {
      const mode = this.hasOpenSession ? "attendance-out" : "attendance-in";
      this.openCamera(mode);
    },

    async confirmLenh(l, accept) {
      this.lenh.acting = true;
      try {
        await api.post(`/api/lenh/${l.idLenh}/confirm`, { accept });
        this.toastSuccess(accept ? "Đã đồng ý lệnh" : "Đã từ chối lệnh");
        await this.fetchMyLenh();
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'Cập nhật thất bại', text: (e?.response?.data?.message || 'Không thể cập nhật xác nhận lệnh') });
      } finally { this.lenh.acting = false; }
    },

    canPunchLenh(l) {
      if ((l?.trangThai || '').toUpperCase() === 'ENDED') return false;
      return true;
    },
    lenhHasOpen(l) {
      const cc = l?.chamCong || {};
      return !!cc.gioVao && !cc.gioRa;
    },
    async handleLenhPunch(l) {
      try {
        const mode = this.lenhHasOpen(l) ? 'lenh-out' : 'lenh-in';
        await this.openCamera(mode, l.idLenh);
      } catch (e) { console.error(e); }
    },

    async showLenhDetail(l) {
      try {
        const { data } = await api.get(`/api/lenh/${l.idLenh}`);
        const d = data?.data || { lenh: l, assignments: [], chamCongList: [] };
        const html = this.buildLenhDetailHtml(d, l);
        Swal.fire({
          width: 900,
          title: `<div class="text-left">
                    <div class="badge badge-pill ${l.kieuThuong === 'HOURLY' ? 'badge-primary' : 'badge-success'} mr-2">${this.escapeHtml(l.kieuThuong || '')}</div>
                    <span class="text-gradient-strong">${this.escapeHtml(l.tieuDe || '')}</span>
                  </div>`,
          html,
          showConfirmButton: true,
          confirmButtonText: 'Đóng',
          customClass: { popup: 'swal2-dashboard' }
        });
      } catch {
        Swal.fire({ icon: 'error', title: 'Không tải được chi tiết', text: 'Vui lòng thử lại sau' });
      }
    },
    buildLenhDetailHtml(d, fallbackLenh) {
      const myCC = (fallbackLenh && fallbackLenh.chamCong) ? fallbackLenh.chamCong : (d.chamCongList?.[0] || null);
      const L = d.lenh || fallbackLenh || {};
      const myBlock = myCC ? `
        <div class="border rounded p-2 mt-2">
          <div class="mb-1"><b>Chấm công của tôi</b></div>
          <div class="row small">
            <div class="col-md-6"><div>Vào: ${myCC.gioVao ? this.formatDateTime(myCC.gioVao) : '—'} (${this.escapeHtml(myCC.vaoTrangThai || '—')})</div></div>
            <div class="col-md-6"><div>Ra: ${myCC.gioRa ? this.formatDateTime(myCC.gioRa) : '—'} (${this.escapeHtml(myCC.raTrangThai || '—')})</div></div>
            <div class="col-md-6"><div>Bắt đầu tính: ${myCC.effectiveStart ? this.formatDateTime(myCC.effectiveStart) : '—'}</div></div>
            <div class="col-md-6"><div>Đóng ca bởi: <span class="badge ${myCC.checkoutBy === 'MANAGER' ? 'badge-dark' : 'badge-info'}">${this.escapeHtml(myCC.checkoutBy || '—')}</span></div></div>
            <div class="col-md-6"><div>Giờ/Công: ${myCC.soGioThuong ? myCC.soGioThuong + ' h' : (myCC.soCongThuong || 0) + ' công'}</div></div>
            <div class="col-md-6"><div>Tiền: <b>${this.formatMoney(myCC.soTienThuong || 0)}</b></div></div>
            <div class="col-12 mt-2">
              ${myCC.anhVaoUrl ? `<img src="${this.escapeAttr(myCC.anhVaoUrl)}" style="height:92px;width:auto;border-radius:6px;border:1px solid #eee;margin-right:8px;">` : ''}
              ${myCC.anhRaUrl ? `<img src="${this.escapeAttr(myCC.anhRaUrl)}"  style="height:92px;width:auto;border-radius:6px;border:1px solid #eee;">` : ''}
            </div>
          </div>
        </div>
      ` : '<div class="text-muted mt-2">Chưa có chấm công của bạn.</div>';

      const managerPhotos = `
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="small text-muted mb-1">Bắt đầu (QL)</div>
            ${L.qlStartAnhUrl ? `<img src="${this.escapeAttr(L.qlStartAnhUrl)}" class="img-fluid rounded border">` : '<div class="text-muted small">—</div>'}
            <div class="small mt-2">
              <div><b>Thời gian:</b> ${L.qlStartAt ? this.formatDateTime(L.qlStartAt) : '—'}</div>
              <div><b>Vị trí:</b> ${this.escapeHtml(L.qlStartDiaDiemText || '—')}</div>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="small text-muted mb-1">Kết thúc (QL)</div>
            ${L.qlEndAnhUrl ? `<img src="${this.escapeAttr(L.qlEndAnhUrl)}" class="img-fluid rounded border">` : '<div class="text-muted small">—</div>'}
            <div class="small mt-2">
              <div><b>Thời gian:</b> ${L.qlEndAt ? this.formatDateTime(L.qlEndAt) : '—'}</div>
              <div><b>Vị trí:</b> ${this.escapeHtml(L.qlEndDiaDiemText || '—')}</div>
            </div>
          </div>
        </div>
      `;

      const info = `
        <div class="row">
          <div class="col-md-6"><b>Loại:</b> <span class="badge badge-secondary">${this.escapeHtml(L.loaiLenh || '')}</span></div>
          <div class="col-md-6"><b>Đơn giá:</b> <span class="badge badge-dark">${this.formatMoney(L.tienCong || 0)}</span></div>
          <div class="col-md-6"><b>Bắt đầu:</b> ${L.batDau ? this.formatDateTime(L.batDau) : '—'}</div>
          <div class="col-md-6"><b>Kết thúc:</b> ${L.ketThuc ? this.formatDateTime(L.ketThuc) : '—'}</div>
          <div class="col-md-6"><b>Trạng thái:</b> <span class="badge ${L.trangThai === 'RUNNING' ? 'badge-info' : (L.trangThai === 'ENDED' ? 'badge-success' : 'badge-secondary')}">${this.escapeHtml(L.trangThai || '')}</span></div>
        </div>
      `;
      const support = (L.hoTroCom || L.hoTroXangXe) ? `
  <div class="row mt-2 small">
    ${L.hoTroCom ? `<div class="col-md-6"><b>Hỗ trợ cơm:</b> ${this.formatMoney(L.hoTroCom || 0)}</div>` : ''}
    ${L.hoTroXangXe ? `<div class="col-md-6"><b>Hỗ trợ xăng:</b> ${this.formatMoney(L.hoTroXangXe || 0)}</div>` : ''}
  </div>
` : '';
      return `<div class="text-left">
          <div class="mb-2 text-muted">${this.escapeHtml(L.moTa || '')}</div>
          ${info}
          ${support}
          <hr/>
          ${managerPhotos}
          ${myBlock}
        </div>`;

    },

    /* ===== Lightbox & Toast ===== */
    openLB(imgs, index = 0) { this.lb.imgs = imgs || []; this.lb.index = index || 0; this.lb.visible = true; },
    toastSuccess(msg) { this.toast ? this.toast.success(msg) : console.log(msg); },
    escapeHtml(s) { return String(s).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m])); },
    escapeAttr(s) { return this.escapeHtml(s); },

    /* ===== NGHỈ PHÉP: List ===== */
    async fetchMyLeaves() {
      this.leaves.loading = true;
      try {
        const params = { page: this.leavePage.number, size: this.leavePage.size };
        if (this.leaveFilter.from) params.from = this.leaveFilter.from;
        if (this.leaveFilter.to) params.to = this.leaveFilter.to;
        if (this.leaveFilter.status && this.leaveFilter.status !== 'ALL') params.status = this.leaveFilter.status;
        if (this.leaveFilter.keyword) params.keyword = this.leaveFilter.keyword;

        const { data } = await api.get("/api/nghi-phep/my", { params });
        const pg = data?.data || { content: [], number: 0, size: this.leavePage.size, totalPages: 1, totalElements: 0 };
        this.leaves.list = pg.content || [];
        this.leavePage.number = pg.number ?? 0;
        this.leavePage.size = pg.size ?? this.leavePage.size;
        this.leavePage.totalPages = pg.totalPages ?? 1;
        this.leavePage.totalElements = pg.totalElements ?? (pg.content?.length || 0);
      } catch {
        this.leaves.list = [];
        this.leavePage.totalPages = 1;
        this.leavePage.totalElements = 0;
      } finally {
        this.leaves.loading = false;
      }
    },
    changeLeavePage(p) {
      const np = Math.max(0, Math.min(p, (this.leavePage.totalPages || 1) - 1));
      if (np !== this.leavePage.number) {
        this.leavePage.number = np;
        this.fetchMyLeaves();
      }
    },
    changePendingPage(p) {
      const np = Math.max(0, Math.min(p, (this.pendingPager.totalPages || 1) - 1));
      if (np !== this.pendingPager.number) this.pendingPager.number = np;
    },
    changeActivePage(p) {
      const np = Math.max(0, Math.min(p, (this.activePager.totalPages || 1) - 1));
      if (np !== this.activePager.number) this.activePager.number = np;
    },
    onDonePageChange(p) {
      const np = Math.max(0, Math.min(p, (this.pageDone.totalPages || 1) - 1));
      if (np !== this.pageDone.number) this.pageDone.number = np;
    },
    changeDoneMonthPage(p) {
      const np = Math.max(0, Math.min(p, (this.doneMonthPager.totalPages || 1) - 1));
      if (np !== this.doneMonthPager.number) this.doneMonthPager.number = np;
    },

    leaveTitle(lv) {
      const code = lv.ma || lv.code || ('#' + (lv.idNghiPhep ?? ''));
      return `Đơn ${code}`;
    },
    statusBadgeClass(s) {
      const x = (s || '').toUpperCase();
      return {
        'badge-warning': x === 'PENDING',
        'badge-success': x === 'APPROVED',
        'badge-danger': x === 'REJECTED',
        'badge-secondary': x === 'CANCELLED' || 'CANCELED' === x
      };
    },
    mapStatus(s) {
      const x = (s || '').toUpperCase();
      if (x === 'PENDING') return 'Chờ duyệt';
      if (x === 'APPROVED') return 'Đã duyệt';
      if (x === 'REJECTED') return 'Từ chối';
      if (x === 'CANCELLED' || x === 'CANCELED') return 'Đã huỷ';
      return x || '—';
    },
    leaveCardClass(s) {
      const x = (s || '').toUpperCase();
      return {
        'leave-pending': x === 'PENDING',
        'leave-approved': x === 'APPROVED',
        'leave-rejected': x === 'REJECTED',
        'leave-cancelled': x === 'CANCELLED' || 'CANCELED' === x
      };
    },
    calcLeaveUnits(lv) {
      try {
        const list = lv.chiTiet || lv.chiTietNgay || [];
        if (!list.length) return null;
        let sum = 0;
        for (const it of list) {
          const b = (it.buoi || it.session || '').toUpperCase();
          if (b === 'FULL' || b === 'ALL') sum += 1;
          else if (b === 'SANG' || b === 'CHIEU' || b === 'AM' || b === 'PM' || b === 'HALF') sum += 0.5;
        }
        return sum || null;
      } catch { return null; }
    },
    canCancelLeave(lv) {
      const st = (lv.trangThai || '').toUpperCase();
      if (st !== 'PENDING') return false;
      const today = this.todayStr();
      return !lv.tuNgay || this.parseYmd(lv.tuNgay) >= this.startOfDayYmd(today);
    },
    async cancelLeave(lv) {
      try {
        const ok = await Swal.fire({
          icon: 'warning',
          title: 'Huỷ đơn nghỉ?',
          text: 'Bạn chắc chắn muốn huỷ đơn nghỉ này?',
          showCancelButton: true,
          confirmButtonText: 'Huỷ đơn',
          cancelButtonText: 'Không'
        });
        if (!ok.isConfirmed) return;

        this.leaves.acting = true;
        await api.post(`/api/nghi-phep/my/${lv.idNghiPhep}/huy`);
        this.toastSuccess('Đã huỷ đơn nghỉ');
        await this.fetchMyLeaves();
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'Không thể huỷ', text: e?.response?.data?.message || 'Vui lòng thử lại.' });
      } finally {
        this.leaves.acting = false;
      }
    },

    /* ===== Đồng bộ filter Done theo tháng ===== */
    setDoneMonthRange() {
      const y = this.mm.y, m = this.mm.m;
      const mStr = String(m).padStart(2, '0');
      const from = `${y}-${mStr}-01`;
      const to = this.monthEndStr(y, m);
      if (!this.doneFilter) this.doneFilter = {};
      this.doneFilter.from = from;
      this.doneFilter.to = to;
      this.pageDone.number = 0;
      this.doneMonthPager.number = 0;
    },

    /* ===== Leave Modal ===== */
    openLeaveModal() {
      this.leaveModal.open = true;
      this.leaveModal.tuNgay = this.todayStr();
      this.leaveModal.denNgay = this.todayStr();
      this.leaveModal.items = [];
      this.onLeaveRangeChange();
    },
    closeLeaveModal() { this.leaveModal.open = false; },
    onLeaveRangeChange() {
      try {
        const from = this.leaveModal.tuNgay, to = this.leaveModal.denNgay;
        if (!from || !to) { this.leaveModal.items = []; return; }
        const d1 = this.parseYmd(from); const d2 = this.parseYmd(to);
        if (d2 < d1) { this.leaveModal.items = []; return; }
        const out = [];
        for (let cur = new Date(d1); cur <= d2; cur = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + 1)) {
          const isSunday = cur.getDay() === 0;
          out.push({
            ngayStr: this.toLocalYmd(cur),
            label: cur.toLocaleDateString("vi-VN"),
            weekday: cur.toLocaleDateString("vi-VN", { weekday: "long" }),
            isSunday,
            buoi: "NONE"
          });
        }
        this.leaveModal.items = out;
      } catch { this.leaveModal.items = []; }
    },
    async submitLeave() {
      if (this.leaveSubmitting) return;
      try {
        const items = (this.leaveModal.items || [])
          .filter(x => x.buoi && x.buoi !== 'NONE')
          .map(x => ({ ngay: x.ngayStr, buoi: x.buoi }));
        if (!items.length) {
          Swal.fire({ icon: 'warning', title: 'Chưa chọn ngày/buổi' });
          return;
        }
        this.leaveSubmitting = true;
        await api.post("/api/nghi-phep/my", {
          tuNgay: this.leaveModal.tuNgay,
          denNgay: this.leaveModal.denNgay,
          lyDo: this.leaveModal.lyDo || '',
          chiTiet: items
        });
        this.toastSuccess("Đã gửi đơn nghỉ");
        this.closeLeaveModal();
        this.fetchMyLeaves();
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'Gửi đơn thất bại', text: e?.response?.data?.message || 'Vui lòng thử lại.' });
      } finally {
        this.leaveSubmitting = false;
      }
    },
 openTamUngModal() {
      this.tamUngModal.open = true;
      this.tamUngModal.soTien = null;
      this.tamUngModal.ghiChu = "";
      this.tamUng.my.error = null;
    },
    closeTamUngModal() {
      this.tamUngModal.open = false;
    },
    async submitTamUng() {
      const soTien = Number(this.tamUngModal.soTien || 0);
      if (!soTien || soTien <= 0) return;
      await this.tamUng.createMy({ soTien, ghiChu: this.tamUngModal.ghiChu });
      this.closeTamUngModal();
      // optional: toast
    },
    tamUngStatusBadge(st) {
      const s = (st || "").toUpperCase();
      if (s === "APPROVED") return "badge-success";
      if (s === "REJECTED") return "badge-danger";
      if (s === "CANCELLED") return "badge-secondary";
      return "badge-warning"; // PENDING
    },
  },
  }
</script>

<style scoped>
.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
}

.shadow-soft {
  box-shadow: 0 8px 24px rgba(0, 0, 0, .06);
}

.border-left-primary {
  border-left: 4px solid #0d6efd22;
}

.border-left-warning {
  border-left: 4px solid #ffc10733;
}

.border-left-success {
  border-left: 4px solid #28a74533;
}

.border-left-info {
  border-left: 4px solid #17a2b833;
}

.text-gradient {
  background: linear-gradient(90deg, #0d6efd, #20c997);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.text-gradient-strong {
  background: linear-gradient(90deg, #7b61ff, #00d4ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.btn-cta {
  box-shadow: 0 8px 16px rgba(13, 110, 253, .25);
}

.order-card {
  transition: box-shadow .2s, transform .05s;
}

.order-card:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, .08);
  transform: translateY(-1px);
}

.order-pending {
  border-left: 4px solid #ffc107;
  background: linear-gradient(180deg, #fff, #fffbea);
}

.order-active {
  border-left: 4px solid #17a2b8;
  background: linear-gradient(180deg, #fff, #eefbff);
}

.order-done {
  border-left: 4px solid #28a745;
  background: linear-gradient(180deg, #fff, #effff3);
}

.order-title-link {
  color: #0d6efd;
  text-decoration: none;
}

.order-title-link:hover {
  text-decoration: underline;
}

.leave-card {
  transition: box-shadow .2s, transform .05s;
}

.leave-card:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, .08);
  transform: translateY(-1px);
}

.leave-pending {
  border-left: 4px solid #ffc107;
  background: linear-gradient(180deg, #fff, #fffbea);
}

.leave-approved {
  border-left: 4px solid #28a745;
  background: linear-gradient(180deg, #fff, #effff3);
}

.leave-rejected {
  border-left: 4px solid #dc3545;
  background: linear-gradient(180deg, #fff, #fff1f1);
}

.leave-cancelled {
  border-left: 4px solid #6c757d;
  background: linear-gradient(180deg, #fff, #f6f6f6);
}

.camera-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .70);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.camera-box {
  width: min(96vw, 860px);
  background: #fff;
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, .35);
}

.camera-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 8px;
  flex-wrap: wrap;
}

.camera-video {
  width: 100%;
  border-radius: 12px;
  background: #000;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.camera-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}

.confirm-pane {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirm-img {
  max-width: 100%;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.ellipsis-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.day-col {
  min-width: 34px;
  width: 34px;
  text-align: center;
  padding: 4px 2px;
  vertical-align: middle;
}

.day-cell {
  cursor: pointer;
  position: relative;
}

.sunday-cell {
  background: #fafafa;
}

.table .fa {
  font-size: 12px;
}

.half-day {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
}

.half-day .half {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 18px;
  line-height: 1;
}

.avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-block;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar-fallback {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  color: #666;
  font-weight: 700;
  border-radius: 50%;
}

.img-thumb {
  width: 96px;
  height: 64px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #eee;
}

.clickable {
  cursor: zoom-in;
}

:deep(.swal2-dashboard) {
  border-radius: 12px;
}

:deep(.swal2-dashboard .swal2-confirm) {
  background: linear-gradient(90deg, #0d6efd, #20c997) !important;
  border: none !important;
}

@media (max-width: 576px) {

  .order-card,
  .leave-card {
    padding: 10px !important;
  }

  .punch-btn {
    width: 100%;
  }
}

.stats-list {
  height: 100%;
  overflow-y: auto;
}

.camera-modal--fs {
  position: fixed;
  inset: 0;
  background: #000;
  z-index: 1050;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.camera-box--fs {
  position: relative;
  width: 100vw;
  height: 100vh;
  padding: 0;
  border-radius: 0;
  background: #000;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

.camera-video--fs,
.confirm-img--fs {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.camera-header--fs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  padding-top: calc(env(safe-area-inset-top) + 8px);
  background: linear-gradient(to bottom, rgba(0, 0, 0, .45), rgba(0, 0, 0, 0));
  color: #fff;
  z-index: 2;
}

.camera-actions--fs {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px calc(env(safe-area-inset-bottom) + 16px);
  background: linear-gradient(to top, rgba(0, 0, 0, .45), rgba(0, 0, 0, 0));
  z-index: 2;
}

.btn-cta-fs {
  height: 56px;
  font-size: 18px;
  border-radius: 14px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, .35);
}

.camera-box {
  background: transparent;
  box-shadow: none;
}

.camera-header {
  margin-bottom: 0;
}

.confirm-pane {
  height: 100%;
}

.confirm-img {
  border: none;
}

@media (max-width: 576px) {
  .btn-cta-fs {
    height: 60px;
    font-size: 17px;
  }
}

.order-flag {
  position: absolute;
  right: 2px;
  top: 2px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
  font-size: 11px;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
}

.order-flag i {
  font-size: 11px;
}

.order-badge {
  font-size: 10px;
  background: rgba(255, 255, 255, .25);
  padding: 0 4px;
  border-radius: 6px;
}

.order-flag--default {
  background: #0d6efd;
}

.order-flag--ot {
  background: #fd7e14;
}

.order-flag--dd {
  background: #17a2b8;
}

.order-flag--sun {
  background: #28a745;
}

.legend-flag {
  transform: scale(.95);
  margin-right: 6px;
}

.quad-day {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.quad-row {
  display: flex;
  justify-content: center;
}

.quad-item {
  width: 14px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.holiday-cell {
  background-color: #fff7e6;
}

.leave-cell {
  box-shadow: inset 0 0 0 1px rgba(40, 167, 69, 0.35);
}

.leave-dot i {
  font-size: 10px;
}

.half-day .half.third {
  height: 14px;
  font-size: 10px;
}

.orders-row {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
  margin-top: 1px;
}

.orders-row .order-count {
  margin-left: 2px;
  font-size: 9px;
}
</style>
